(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bt-info-row"] && !Shopify.designMode) return;
  try {
    (function () {
    function open(uid) {
      var panel = document.getElementById('bt-ir-panel-' + uid);
      var overlay = document.getElementById('bt-ir-overlay-' + uid);
      if (panel) panel.classList.add('is-active');
      if (overlay) overlay.classList.add('is-active');
      document.documentElement.style.overflow = 'hidden';
    }
    function close(uid) {
      var panel = document.getElementById('bt-ir-panel-' + uid);
      var overlay = document.getElementById('bt-ir-overlay-' + uid);
      if (panel) panel.classList.remove('is-active');
      if (overlay) overlay.classList.remove('is-active');
      document.documentElement.style.overflow = '';
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bt-ir-trigger]');
      if (t) { e.preventDefault(); open(t.getAttribute('data-bt-ir-trigger')); return; }
      var c = e.target.closest('[data-bt-ir-close]');
      if (c) { e.preventDefault(); close(c.getAttribute('data-bt-ir-close')); return; }
      var o = e.target.closest('[data-bt-ir-overlay]');
      if (o) { close(o.getAttribute('data-bt-ir-overlay')); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.bt-ir-panel.is-active').forEach(function (p) {
        var uid = p.id.replace(/^bt-ir-panel-/, '');
        close(uid);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bt-review-summary"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      if (!root || root.__btRsumReady) return;
      root.__btRsumReady = true;

      var apiBase = root.getAttribute('data-api-base');
      var storeId = root.getAttribute('data-store-id');
      var apiStore = root.getAttribute('data-store') || 'ua';
      var handle = root.getAttribute('data-handle');
      var showDist = root.getAttribute('data-show-dist') === 'true';
      var ratingOffset = parseFloat(root.getAttribute('data-rating-offset')) || 0;
      var ratingMin = parseFloat(root.getAttribute('data-rating-min'));
      if (isNaN(ratingMin)) ratingMin = 4.0;

      var scrollOffset = parseInt(root.getAttribute('data-scroll-offset'), 10);
      if (isNaN(scrollOffset)) scrollOffset = 20;

      var loadingEl = root.querySelector('[data-bt-rsum-loading]');
      var contentEl = root.querySelector('[data-bt-rsum-content]');
      var emptyEl = root.querySelector('[data-bt-rsum-empty]');
      var numberEl = root.querySelector('[data-bt-rsum-number]');
      var starsEl = root.querySelector('[data-bt-rsum-stars]');
      var countEl = root.querySelector('[data-bt-rsum-count]');
      var rowEl = root.querySelector('[data-bt-rsum-scroll]');
      var countLinkEl = root.querySelector('[data-bt-rsum-count-link]');

      /* --- scroll to the reviews section on the same page ---------------
         The `count_link` setting is usually just '#reviews', but the reviews
         section has no such anchor, so a plain href goes nowhere. Resolve the
         target ourselves: honour the anchor if it really exists, otherwise
         fall back to the reviews grid section markup. */
      function findReviewsTarget() {
        var href = countLinkEl ? (countLinkEl.getAttribute('href') || '') : '';
        if (href.charAt(0) === '#' && href.length > 1) {
          try {
            var byHash = document.querySelector(href);
            if (byHash) return byHash;
          } catch (e) { /* invalid selector — ignore */ }
        }
        return document.querySelector('[data-bt-rga]')
          || document.querySelector('[data-bt-reviews-grid]')
          || document.getElementById('reviews');
      }

      /* Height of whatever sticky/fixed header is currently pinned to the top,
         so the section heading does not end up hidden behind it. */
      function stickyHeaderHeight() {
        var max = 0;
        var nodes = document.querySelectorAll('header, .header, sticky-header, [data-sticky-header]');
        for (var i = 0; i < nodes.length; i++) {
          var box = nodes[i].getBoundingClientRect();
          if (!box.height || box.top > 1) continue;
          var pos = window.getComputedStyle(nodes[i]).position;
          if (pos === 'fixed' || pos === 'sticky') max = Math.max(max, box.height);
        }
        return max;
      }

      function scrollToReviews(e) {
        var target = findReviewsTarget();
        if (!target) return;
        if (e) e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset
          - stickyHeaderHeight() - scrollOffset;
        if (top < 0) top = 0;
        try {
          window.scrollTo({ top: top, behavior: 'smooth' });
        } catch (err) {
          window.scrollTo(0, top);
        }
      }

      if (rowEl) {
        rowEl.addEventListener('click', function (e) {
          if (!findReviewsTarget()) return;
          scrollToReviews(e);
        });
        rowEl.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          if (!findReviewsTarget()) return;
          scrollToReviews(e);
        });
        /* Mark as clickable only when there is somewhere to go. */
        setTimeout(function () {
          if (!findReviewsTarget()) return;
          rowEl.classList.add('bt-rsum__row--clickable');
          if (!countLinkEl) {
            rowEl.setAttribute('role', 'button');
            rowEl.setAttribute('tabindex', '0');
          }
        }, 0);
      }

      /* storeId is legacy and ignored by the API — `store` is what picks
         the store (ua = Bricktopia, pl = Kloniko). */
      var url = apiBase + '/api/public/reviews/summary?storeId=' + encodeURIComponent(storeId)
        + '&store=' + encodeURIComponent(apiStore);
      if (handle) url += '&handle=' + encodeURIComponent(handle);

      /* Apply optional rating offset — useful when the real average is 5.0
         and the merchant wants to display 4.8 to seem more credible.
         Final value is clamped to [ratingMin, 5.0] so it never goes below
         the floor or above 5. */
      function adjustAverage(avg) {
        var v = (typeof avg === 'number' ? avg : parseFloat(avg)) + ratingOffset;
        if (v < ratingMin) v = ratingMin;
        if (v > 5) v = 5;
        return v;
      }

      /* One request per URL for the whole page: the product gallery's reviews
         plate (assets/bt-gallery-slides.js) reads the same promise instead of
         asking the API again. Whichever of the two runs first makes the call. */
      var summaryCache = window.__btReviewsSummary = window.__btReviewsSummary || {};
      var summaryRequest = summaryCache[url]
        || (summaryCache[url] = fetch(url).then(function (r) { return r.json(); }));

      summaryRequest.then(function (data) {
        if (loadingEl) loadingEl.hidden = true;
        if (!data || !data.success || !data.count) {
          if (emptyEl) emptyEl.hidden = false;
          return;
        }
        if (contentEl) contentEl.hidden = false;
        var displayAvg = adjustAverage(data.average);
        if (numberEl) numberEl.textContent = (Math.round(displayAvg * 10) / 10).toFixed(1);
        if (countEl) countEl.textContent = data.count;
        if (starsEl) {
          var rounded = Math.round(displayAvg);
          var stars = '';
          for (var i = 1; i <= 5; i++) stars += (i <= rounded ? '★' : '☆');
          starsEl.textContent = stars;
        }
        if (showDist && data.distribution) {
          var max = 0;
          Object.keys(data.distribution).forEach(function (k) {
            if (data.distribution[k] > max) max = data.distribution[k];
          });
          for (var s = 1; s <= 5; s++) {
            var count = data.distribution[String(s)] || 0;
            var pct = max > 0 ? (count / max * 100) : 0;
            var bar = root.querySelector('[data-bt-rsum-bar="' + s + '"]');
            var cnt = root.querySelector('[data-bt-rsum-bar-count="' + s + '"]');
            if (bar) bar.style.width = pct + '%';
            if (cnt) cnt.textContent = count;
          }
        }
      }).catch(function () {
        if (loadingEl) loadingEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
      });
    }
    document.querySelectorAll('[data-bt-rsum]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-rsum]').forEach(init);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-block-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    /* --- Position teleport — той самий патерн, що cart-upsell /
       cart-frame-upsell. Селектор містить УСІ апсел-блоки, щоб порядок
       data-tp-order був наскрізним між ними. --- */
    var TP_SELECTOR = '[data-cart-fast-delivery],[data-bt-upsell],[data-bt-fupsell],[data-bt-figupsell],[data-bt-updivider],[data-bt-blkupsell]';

    function stampOrders() {
      /* Морф кошика ре-рендерить блок у рідній обгортці, а стара
         телепортнута копія морфом не зноситься → дедуп по data-bt-block-id
         (лишаємо копію всередині shopify-block). */
      var dupGroups = {};
      document.querySelectorAll('[data-bt-blkupsell][data-bt-block-id]').forEach(function (n) {
        var bid = n.getAttribute('data-bt-block-id');
        (dupGroups[bid] = dupGroups[bid] || []).push(n);
      });
      Object.keys(dupGroups).forEach(function (bid) {
        var list = dupGroups[bid];
        if (list.length < 2) return;
        var keep = null;
        for (var d = 0; d < list.length; d++) {
          if (list[d].closest('shopify-block, .shopify-block')) { keep = list[d]; break; }
        }
        if (!keep) keep = list[0];
        list.forEach(function (n) { if (n !== keep) n.remove(); });
      });

      var wrappers = Array.prototype.slice.call(document.querySelectorAll('shopify-block, .shopify-block'));
      document.querySelectorAll(TP_SELECTOR).forEach(function (n, i) {
        if (!n.__btOrigWrap || !n.__btOrigWrap.isConnected) {
          var w = n.closest('shopify-block, .shopify-block');
          if (w) n.__btOrigWrap = w;
        }
        var idx = n.__btOrigWrap ? wrappers.indexOf(n.__btOrigWrap) : -1;
        n.setAttribute('data-tp-order', idx >= 0 ? idx : 500 + i);
      });
    }
    stampOrders();

    function insertOrdered(target, el) {
      var mine = parseInt(el.getAttribute('data-tp-order') || '999', 10);
      var before = null;
      for (var i = 0; i < target.children.length; i++) {
        var c = target.children[i];
        if (c === el || !c.getAttribute) continue;
        var o = c.getAttribute('data-tp-order');
        if (o !== null && parseInt(o, 10) > mine) { before = c; break; }
      }
      if (before) target.insertBefore(el, before); else target.appendChild(el);
    }

    function findTarget(pos) {
      if (pos === 'under-summary') {
        return document.querySelector('.cart__summary-container')
            || document.querySelector('[data-cart-summary]')
            || (document.querySelector('.cart__summary-totals') && document.querySelector('.cart__summary-totals').parentElement);
      }
      if (pos === 'under-products') {
        return (document.querySelector('.cart-items__table') && document.querySelector('.cart-items__table').parentElement)
            || document.querySelector('cart-items-component')
            || document.querySelector('.cart-items')
            || document.querySelector('#cart-form');
      }
      return null;
    }

    function moveBlock(el) {
      /* Учасників каруселі рухає сам карусельний модуль (обгорткою). */
      if (el.closest('[data-btc-track]')) return;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var pos = isMobile ? (el.dataset.posMobile || 'default') : (el.dataset.posDesktop || 'default');
      if (pos === 'default') {
        if (el.__bbuOrigParent && el.parentElement !== el.__bbuOrigParent) el.__bbuOrigParent.appendChild(el);
        return;
      }
      if (!el.__bbuOrigParent) el.__bbuOrigParent = el.parentElement;
      var target = findTarget(pos);
      if (target) insertOrdered(target, el);
    }

    /* --- Auto-size картинки під мініатюри товарів кошика (той самий
       патерн, що cart-frame-upsell) — щоб висота картки збігалась із
       сусідніми апселами. --- */
    function syncMediaSize(el) {
      if (el.dataset.matchCartMedia !== '1') return;
      var ref = document.querySelector('.cart-items__media-container')
             || document.querySelector('.cart-items__media img')
             || document.querySelector('.cart-items__media');
      if (!ref) return;
      var r = ref.getBoundingClientRect();
      if (r.width < 20 || r.height < 20) return;
      var size = Math.round(Math.min(r.width, r.height));
      el.style.setProperty('--bt-blkupsell-media', size + 'px');
      el.style.setProperty('--bt-blkupsell-media-mobile', size + 'px');
      var br = getComputedStyle(ref).borderRadius;
      if (br && br !== '0px') el.style.setProperty('--bt-blkupsell-media-radius', br);
    }

    function bind(el) {
      if (!el || el.__bbuReady) return;
      el.__bbuReady = true;
      moveBlock(el);
      syncMediaSize(el);
      setTimeout(function () { syncMediaSize(el); }, 500);
      setTimeout(function () { syncMediaSize(el); }, 1500);
    }

    document.querySelectorAll('[data-bt-blkupsell]').forEach(bind);
    /* Карусельний модуль живе в cart-upsell / cart-frame-upsell —
       тут лише смикаємо його, якщо він є (галочка "Об'єднати в карусель"). */
    if (window.__btUpsellCarousel) window.__btUpsellCarousel.schedule();

    document.addEventListener('shopify:block:select', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-blkupsell]').forEach(bind);
    });
    document.addEventListener('shopify:section:load', function () {
      stampOrders();
      document.querySelectorAll('[data-bt-blkupsell]').forEach(bind);
      if (window.__btUpsellCarousel) window.__btUpsellCarousel.schedule();
    });

    /* Кошик morph-иться без перезавантаження — свіжі елементи блока
       треба заново привʼязати (телепорт/порядок). */
    var rebindT;
    function scheduleRebind() {
      clearTimeout(rebindT);
      rebindT = setTimeout(function () {
        stampOrders();
        document.querySelectorAll('[data-bt-blkupsell]').forEach(bind);
        if (window.__btUpsellCarousel) window.__btUpsellCarousel.schedule();
      }, 120);
    }
    document.addEventListener('cart:refresh', scheduleRebind);
    document.addEventListener('cart:updated', scheduleRebind);
    new MutationObserver(function () {
      if (document.querySelector('[data-bt-blkupsell]:not([data-tp-order])')) scheduleRebind();
    }).observe(document.body, { childList: true, subtree: true });

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        document.querySelectorAll('[data-bt-blkupsell]').forEach(function (el) {
          moveBlock(el);
          syncMediaSize(el);
        });
      }, 200);
    });
    window.addEventListener('load', function () {
      document.querySelectorAll('[data-bt-blkupsell]').forEach(syncMediaSize);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-fast-delivery"] && !Shopify.designMode) return;
  try {
    /* Block-level overrides for FastDeliverySystem:
       - Position teleport (default / under-summary / under-products)
       - Fixed-mode pricing: when merchant chose a product, override the
         button text + click-handler so it adds THAT product instead of
         the auto-tier variant. Cart-summary's FastDeliverySystem only
         updates the button label if it sees the auto-mode marker — we
         repaint after each cart update so our fixed price/text wins.
       - Custom delivery_api_url: overrides the value cart-summary will
         use for FetchDeliverySettings on next reload (stores in
         BricktopiaConfig). */
  (function () {
    var blocks = document.querySelectorAll('[data-cart-fast-delivery]');
    if (!blocks.length) return;

    /* Порядок телепортнутих блоків = порядок блоків у кастомайзері
       (див. коментар у cart-upsell.liquid). */
    var TP_SELECTOR = '[data-cart-fast-delivery],[data-bt-upsell],[data-bt-fupsell],[data-bt-figupsell],[data-bt-updivider]';
    /* Номер порядку беремо з позиції рідної обгортки <shopify-block> серед
       усіх обгорток: вони лишаються на місці після телепорту, тож і після
       ре-рендера секції в редакторі порядок рахується правильно (старий
       one-shot штамп давав новоствореним елементам 999 → блок падав у кінець
       списку, звідси «на ПК порядок не відповідає»). */
    function stampOrders() {
      /* Морф кошика ре-рендерить блок у рідній обгортці, а СТАРА
         телепортнута копія (вона живе вже ПОЗА обгорткою) морфом не
         зноситься → блок дублювався після кожної зміни кошика. Лишаємо
         свіжу копію (ту, що в обгортці), старі прибираємо. */
      var dupGroups = {};
      document.querySelectorAll('[data-bt-block-id]').forEach(function (n) {
        var bid = n.getAttribute('data-bt-block-id');
        (dupGroups[bid] = dupGroups[bid] || []).push(n);
      });
      Object.keys(dupGroups).forEach(function (bid) {
        var list = dupGroups[bid];
        if (list.length < 2) return;
        /* Свіжа копія (щойно ре-рендерена морфом) — ПРЯМА дитина своєї
           обгортки <shopify-block>. Телепортнута стара копія живе в
           контейнері саммері/товарів (а той сам всередині обгортки
           cart-summary), тож старий `closest('shopify-block')` бачив
           ОБИДВІ як «в обгортці» і міг лишити стару → два блоки з різними
           цінами після видалення товару. Тримаємось за ПРЯМОГО предка. */
        var keep = null;
        for (var d = 0; d < list.length; d++) {
          var pp = list[d].parentElement;
          if (pp && (pp.tagName === 'SHOPIFY-BLOCK' || (pp.classList && pp.classList.contains('shopify-block')))) { keep = list[d]; break; }
        }
        if (!keep) keep = list[0];
        list.forEach(function (n) { if (n !== keep) n.remove(); });
      });

      var wrappers = Array.prototype.slice.call(document.querySelectorAll('shopify-block, .shopify-block'));
      document.querySelectorAll(TP_SELECTOR).forEach(function (n, i) {
        if (!n.__btOrigWrap || !n.__btOrigWrap.isConnected) {
          var w = n.closest('shopify-block, .shopify-block');
          if (w) n.__btOrigWrap = w;
        }
        var idx = n.__btOrigWrap ? wrappers.indexOf(n.__btOrigWrap) : -1;
        n.setAttribute('data-tp-order', idx >= 0 ? idx : 500 + i);
      });
    }
    stampOrders();
    function insertOrdered(target, el) {
      var mine = parseInt(el.getAttribute('data-tp-order') || '999', 10);
      var before = null;
      for (var i = 0; i < target.children.length; i++) {
        var c = target.children[i];
        if (c === el || !c.getAttribute) continue;
        var o = c.getAttribute('data-tp-order');
        if (o !== null && parseInt(o, 10) > mine) { before = c; break; }
      }
      if (before) target.insertBefore(el, before); else target.appendChild(el);
    }


    /* If any block specified an API URL, propagate it onto the global
       config so cart-summary's FastDeliverySystem picks it up. The block
       declared LAST wins if there are multiple. */
    blocks.forEach(function (el) {
      var url = el.dataset.deliveryApiUrl;
      if (url && window.BricktopiaConfig) {
        window.BricktopiaConfig.deliveryApiUrl = url;
      }
    });

    function findTarget(pos) {
      if (pos === 'under-summary') {
        return document.querySelector('.cart__summary-container')
            || document.querySelector('[data-cart-summary]')
            || (document.querySelector('.cart__summary-totals') && document.querySelector('.cart__summary-totals').parentElement);
      }
      if (pos === 'under-products') {
        return (document.querySelector('.cart-items__table') && document.querySelector('.cart-items__table').parentElement)
            || document.querySelector('cart-items-component')
            || document.querySelector('.cart-items')
            || document.querySelector('#cart-form');
      }
      return null;
    }
    function moveBlock(el) {
      /* Копія, яку морф кошика вже викинув зі сторінки, назад НЕ вставляємо
         (інакше вона воскресає поруч зі свіжою — див. обробник resize). */
      if (!el.isConnected) return;
      var posDesktop = el.dataset.posDesktop || 'default';
      var posMobile = el.dataset.posMobile || 'default';
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var pos = isMobile ? posMobile : posDesktop;
      if (pos === 'default') {
        if (el.__cfdOrigParent && el.parentElement !== el.__cfdOrigParent) {
          el.__cfdOrigParent.appendChild(el);
        }
        return;
      }
      if (!el.__cfdOrigParent) el.__cfdOrigParent = el.parentElement;
      var target = findTarget(pos);
      if (target) insertOrdered(target, el);
    }

    /* Fixed-mode handler: hijack the click and add the merchant's chosen
       variant. Repaints button text after every cart update so
       FastDeliverySystem's auto-update can't overwrite our fixed price. */
    function applyFixedMode(el) {
      var mode = el.dataset.pricingMode;
      if (mode !== 'fixed') return;
      var variantId = parseInt(el.dataset.fixedVariantId, 10);
      var priceText = el.dataset.fixedPriceText;
      if (!variantId) return;

      var btn = el.querySelector('[data-cfd-btn]');
      var labelEl = el.querySelector('[data-cfd-btn-label]');
      var btnText = (btn && btn.textContent.match(/^\S+/)) ? btn.textContent.match(/^\S+/)[0] : 'Додати';

      function paint() {
        if (labelEl) {
          /* Keep the original button word from textContent before the
             space, then append our fixed price in parentheses. */
          var raw = labelEl.textContent.trim();
          var word = raw.split(/[\s(]/)[0] || btnText;
          labelEl.textContent = word + ' (' + priceText + ')';
        }
      }
      paint();
      /* Re-apply periodically because FastDeliverySystem.updateDeliveryButton()
         may re-render the button on cart updates. */
      setInterval(paint, 1500);

      if (btn && !btn.__cfdBound) {
        btn.__cfdBound = true;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (btn.disabled) return;
          btn.disabled = true;
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1,
                properties: { '_fast_delivery': true, '_fixed_variant': true }
              }]
            })
          }).then(function (r) {
            if (!r.ok) throw new Error('Cart add failed: ' + r.status);
            return r.json();
          }).then(function () {
            try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'cart-fast-delivery-fixed' } })); } catch (_) {}
            setTimeout(function () { window.location.reload(); }, 300);
          }).catch(function (err) {
            console.error('[cart-fast-delivery] Add error:', err);
            btn.disabled = false;
          });
        }, true); /* capture-phase so we beat FastDeliverySystem's listener */
      }
    }

    blocks.forEach(function (el) {
      moveBlock(el);
      applyFixedMode(el);
    });
    document.addEventListener('shopify:section:load', function () {
      stampOrders();
      document.querySelectorAll('[data-cart-fast-delivery]').forEach(function (el) {
        moveBlock(el);
        applyFixedMode(el);
      });
    });

    /* Кошик morph-иться при видаленні/зміні кількості БЕЗ перезавантаження —
       свіжі елементи блока треба заново привʼязати (телепорт, карусель,
       ціни), інакше апсели вискакують угору «сирими». Детектор у
       MutationObserver дивиться на НЕзаштамповані елементи, тож наші власні
       переміщення (вони вже з data-tp-order) ребайнд не тригерять. */
    var rebindT;
    function scheduleRebind() {
      clearTimeout(rebindT);
      rebindT = setTimeout(function () {
        stampOrders();
        document.querySelectorAll('[data-cart-fast-delivery]').forEach(function (el) {
          moveBlock(el);
          applyFixedMode(el);
        });
      }, 120);
    }
    document.addEventListener('cart:refresh', scheduleRebind);
    document.addEventListener('cart:updated', scheduleRebind);
    document.addEventListener('bricktopia:production-updated', scheduleRebind);
    new MutationObserver(function () {
      if (document.querySelector('[data-cart-fast-delivery]:not([data-tp-order])')) scheduleRebind();
    }).observe(document.body, { childList: true, subtree: true });

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      /* Беремо блоки з DOM ЗАНОВО. `blocks` — знімок з першого завантаження:
         після видалення товару морф кошика замінює блок свіжою копією, а стара
         лишається в цьому списку відʼєднаною. iOS Safari шле resize при
         скролі (ховається адресний рядок) → moveBlock вставляв стару копію
         назад у кошик → дві плашки «Dodaj ekspresową wysyłkę» з різними
         цінами (стара — з ціною кошика до видалення). */
      resizeT = setTimeout(function () {
        document.querySelectorAll('[data-cart-fast-delivery]').forEach(moveBlock);
      }, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-figure-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    /* --- Position teleport + порядок (той самий патерн, що cart-upsell) --- */
    var TP_SELECTOR = '[data-cart-fast-delivery],[data-bt-upsell],[data-bt-fupsell],[data-bt-figupsell],[data-bt-updivider]';
    /* Номер порядку беремо з позиції рідної обгортки <shopify-block> серед
       усіх обгорток: вони лишаються на місці після телепорту, тож і після
       ре-рендера секції в редакторі порядок рахується правильно (старий
       one-shot штамп давав новоствореним елементам 999 → блок падав у кінець
       списку, звідси «на ПК порядок не відповідає»). */
    function stampOrders() {
      /* Морф кошика ре-рендерить блок у рідній обгортці, а СТАРА
         телепортнута копія (вона живе вже ПОЗА обгорткою) морфом не
         зноситься → блок дублювався після кожної зміни кошика. Лишаємо
         свіжу копію (ту, що в обгортці), старі прибираємо. */
      var dupGroups = {};
      document.querySelectorAll('[data-bt-block-id]').forEach(function (n) {
        var bid = n.getAttribute('data-bt-block-id');
        (dupGroups[bid] = dupGroups[bid] || []).push(n);
      });
      Object.keys(dupGroups).forEach(function (bid) {
        var list = dupGroups[bid];
        if (list.length < 2) return;
        var keep = null;
        for (var d = 0; d < list.length; d++) {
          if (list[d].closest('shopify-block, .shopify-block')) { keep = list[d]; break; }
        }
        if (!keep) keep = list[0];
        list.forEach(function (n) { if (n !== keep) n.remove(); });
      });

      var wrappers = Array.prototype.slice.call(document.querySelectorAll('shopify-block, .shopify-block'));
      document.querySelectorAll(TP_SELECTOR).forEach(function (n, i) {
        if (!n.__btOrigWrap || !n.__btOrigWrap.isConnected) {
          var w = n.closest('shopify-block, .shopify-block');
          if (w) n.__btOrigWrap = w;
        }
        var idx = n.__btOrigWrap ? wrappers.indexOf(n.__btOrigWrap) : -1;
        n.setAttribute('data-tp-order', idx >= 0 ? idx : 500 + i);
      });
    }
    stampOrders();
    function insertOrdered(target, el) {
      var mine = parseInt(el.getAttribute('data-tp-order') || '999', 10);
      var before = null;
      for (var i = 0; i < target.children.length; i++) {
        var c = target.children[i];
        if (c === el || !c.getAttribute) continue;
        var o = c.getAttribute('data-tp-order');
        if (o !== null && parseInt(o, 10) > mine) { before = c; break; }
      }
      if (before) target.insertBefore(el, before); else target.appendChild(el);
    }
    function findTarget(pos) {
      if (pos === 'under-summary') {
        return document.querySelector('.cart__summary-container')
            || document.querySelector('[data-cart-summary]')
            || (document.querySelector('.cart__summary-totals') && document.querySelector('.cart__summary-totals').parentElement);
      }
      if (pos === 'under-products') {
        return (document.querySelector('.cart-items__table') && document.querySelector('.cart-items__table').parentElement)
            || document.querySelector('cart-items-component')
            || document.querySelector('.cart-items')
            || document.querySelector('#cart-form');
      }
      return null;
    }
    function moveBlock(el) {
      if (el.closest('[data-btc-track]')) return; /* карусель рухає обгортка */
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var pos = isMobile ? (el.dataset.posMobile || 'default') : (el.dataset.posDesktop || 'default');
      if (pos === 'default') {
        if (el.__bguOrigParent && el.parentElement !== el.__bguOrigParent) el.__bguOrigParent.appendChild(el);
        return;
      }
      if (!el.__bguOrigParent) el.__bguOrigParent = el.parentElement;
      var target = findTarget(pos);
      if (target) insertOrdered(target, el);
    }

    /* --- Auto-size картинки під мініатюри товарів кошика --- */
    function syncMediaSize(el) {
      if (el.dataset.matchCartMedia !== '1') return;
      var ref = document.querySelector('.cart-items__media-container')
             || document.querySelector('.cart-items__media img')
             || document.querySelector('.cart-items__media');
      if (!ref) return;
      var r = ref.getBoundingClientRect();
      if (r.width < 20 || r.height < 20) return;
      var size = Math.round(Math.min(r.width, r.height));
      el.style.setProperty('--bt-figupsell-media', size + 'px');
      el.style.setProperty('--bt-figupsell-media-mobile', size + 'px');
      var br = getComputedStyle(ref).borderRadius;
      if (br && br !== '0px') el.style.setProperty('--bt-figupsell-media-radius', br);
    }

    function formatPrice(n, label) {
      var B = window.BtPriceConvert;
      if (B && B.active) return B.format(n) + ' ' + B.symbol;
      var s = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return label ? s + ' ' + label : s;
    }

    /* --- Ціна наступної фігурки з API конструктора --- */
    function loadPrice(el) {
      var url = el.dataset.apiUrl;
      if (!url) return;
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      url += sep + 'position=' + encodeURIComponent(el.dataset.position || '2');
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        if (!d || !d.success) throw new Error('figure-upsell API: bad response');
        if (!(d.percent > 0)) {
          /* Позиція без знижки: ціновий рядок не показуємо; блок ховаємо
             лише якщо мерчант так налаштував. */
          if (el.dataset.hideNoDiscount === '1' && el.dataset.designMode !== '1') {
            el.style.display = 'none';
            if (window.__btUpsellCarousel) window.__btUpsellCarousel.schedule();
          }
          return;
        }
        /* Акція «1+1»: безкоштовна лише БАЗА — «0 грн» збрехало б про допи. */
        if (d.bogo && el.dataset.bogoText) {
          var bogoEl = el.querySelector('[data-bgu-price]');
          if (bogoEl) { bogoEl.textContent = '🎁 ' + el.dataset.bogoText; bogoEl.hidden = false; }
          return;
        }
        /* Ціни API — у валюті магазину; на іншому ринку переводимо їх так, як
           це зробить Shopify (курс + надбавка ринку + округлення). */
        var BPC = window.BtPriceConvert, CONV = !!(BPC && BPC.active);
        if (CONV) { d.discounted = BPC.amount(d.discounted); d.base = BPC.amount(d.base); }
        var label = CONV ? BPC.symbol : (el.dataset.currencyLabel || d.currency || '');
        var tpl = el.dataset.priceTemplate || '{price}';
        var text = tpl
          .replace('{price}', formatPrice(d.discounted, label))
          .replace('{full}', formatPrice(d.base, label))
          .replace('{percent}', String(d.percent));
        var priceEl = el.querySelector('[data-bgu-price]');
        if (priceEl) { priceEl.textContent = text; priceEl.hidden = false; }
        console.log('🧍 Figure upsell price:', d);
      }).catch(function (err) {
        console.error('🧍 Figure upsell price failed:', err);
        /* Без ціни блок все одно має сенс (CTA у конструктор) — не ховаємо. */
      });
    }

    /* --- Карусель апселів (спільний модуль — той самий guarded-код, що в
       cart-upsell/cart-frame-upsell; виконується перший з файлів). --- */
    if (!window.__btUpsellCarousel) {
      window.__btUpsellCarousel = (function () {
        var buildT = null;

        function isMobileMQ() { return window.matchMedia('(max-width: 749px)').matches; }
        function posOf(el) { return isMobileMQ() ? (el.dataset.posMobile || 'default') : (el.dataset.posDesktop || 'default'); }

        function visibleItems() {
          return Array.prototype.slice.call(document.querySelectorAll('[data-bt-carousel="1"]'))
            .filter(function (el) { return el.style.display !== 'none'; })
            .sort(function (a, b) {
              return parseInt(a.getAttribute('data-tp-order') || '999', 10)
                   - parseInt(b.getAttribute('data-tp-order') || '999', 10);
            });
        }

        function slides(wrap) {
          var track = wrap.querySelector('[data-btc-track]');
          return Array.prototype.filter.call(track.children, function (c) {
            return getComputedStyle(c).display !== 'none';
          });
        }

        /* Крок прокрутки = реальна ширина слайда + gap треку. На мобілці
           слайд вужчий за трек (peek наступної картки), тож clientWidth
           треку більше не годиться. */
        function slideStep(wrap) {
          var track = wrap.querySelector('[data-btc-track]');
          var sl = slides(wrap);
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return sl.length ? sl[0].getBoundingClientRect().width + gap : (track.clientWidth || 1);
        }

        function updateNav(wrap) {
          var sl = slides(wrap);
          var track = wrap.querySelector('[data-btc-track]');
          var dots = wrap.querySelector('[data-btc-dots]');
          wrap.classList.toggle('bt-upsell-carousel--single', sl.length < 2);
          var step = slideStep(wrap);
          var idx = step ? Math.round(track.scrollLeft / step) : 0;
          var html = '';
          for (var i = 0; i < sl.length; i++) {
            html += '<button type="button" class="bt-upsell-carousel__dot' + (i === idx ? ' is-active' : '') + '" data-btc-dot="' + i + '" aria-label="' + (i + 1) + '"></button>';
          }
          dots.innerHTML = html;
        }

        function animateTo(track, left) {
          var start = track.scrollLeft;
          var delta = left - start;
          if (!delta) return;
          track.__btcAnim = (track.__btcAnim || 0) + 1;
          var myAnim = track.__btcAnim;
          var dur = 320;
          var t0 = null;
          track.style.scrollSnapType = 'none';
          var ticked = false;
          function stepFn(ts) {
            if (track.__btcAnim !== myAnim) return;
            ticked = true;
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / dur);
            var e = 1 - Math.pow(1 - p, 3);
            track.scrollLeft = start + delta * e;
            if (p < 1) requestAnimationFrame(stepFn);
            else track.style.scrollSnapType = '';
          }
          requestAnimationFrame(stepFn);
          setTimeout(function () {
            if (!ticked && track.__btcAnim === myAnim) {
              track.scrollLeft = left;
              track.style.scrollSnapType = '';
            }
          }, 120);
        }
        function goTo(wrap, idx) {
          var track = wrap.querySelector('[data-btc-track]');
          var count = slides(wrap).length;
          if (idx < 0) idx = count - 1;
          if (idx >= count) idx = 0;
          animateTo(track, idx * slideStep(wrap));
        }

        function bindNav(wrap) {
          var track = wrap.querySelector('[data-btc-track]');
          wrap.addEventListener('click', function (e) {
            var t = e.target;
            if (t.hasAttribute('data-btc-prev')) goTo(wrap, Math.round(track.scrollLeft / slideStep(wrap)) - 1);
            else if (t.hasAttribute('data-btc-next')) goTo(wrap, Math.round(track.scrollLeft / slideStep(wrap)) + 1);
            else if (t.hasAttribute('data-btc-dot')) goTo(wrap, parseInt(t.getAttribute('data-btc-dot'), 10));
          });
          var st;
          track.addEventListener('scroll', function () {
            clearTimeout(st);
            st = setTimeout(function () { updateNav(wrap); }, 80);
          });
        }

        function build() {
          var items = visibleItems();
          var wrap = document.querySelector('[data-bt-upsell-carousel]');
          if (items.length < 2) {
            if (wrap) {
              var track0 = wrap.querySelector('[data-btc-track]');
              while (track0.firstChild) wrap.parentElement.insertBefore(track0.firstChild, wrap);
              wrap.remove();
            }
            return;
          }
          if (!wrap) {
            wrap = document.createElement('div');
            wrap.className = 'bt-upsell-carousel';
            wrap.setAttribute('data-bt-upsell-carousel', '');
            wrap.innerHTML =
              '<div class="bt-upsell-carousel__track" data-btc-track></div>' +
              '<button type="button" class="bt-upsell-carousel__arrow bt-upsell-carousel__arrow--prev" data-btc-prev aria-label="Prev">&#8249;</button>' +
              '<button type="button" class="bt-upsell-carousel__arrow bt-upsell-carousel__arrow--next" data-btc-next aria-label="Next">&#8250;</button>' +
              '<div class="bt-upsell-carousel__dots" data-btc-dots></div>';
            bindNav(wrap);
          }

          var first = items[0];
          wrap.dataset.posDesktop = first.dataset.posDesktop || 'default';
          wrap.dataset.posMobile = first.dataset.posMobile || 'default';
          wrap.setAttribute('data-tp-order', first.getAttribute('data-tp-order') || '0');

          var pos = posOf(first);
          if (pos === 'default') {
            var orig = first.__btUpsellOrigParent || first.__bfuOrigParent || first.__bguOrigParent || null;
            var anchor = orig || (!first.closest('[data-btc-track]') ? first.parentElement : null);
            if (anchor && wrap.parentElement !== anchor) anchor.appendChild(wrap);
          } else {
            var target = findTarget(pos);
            if (target) insertOrdered(target, wrap);
          }
          if (!wrap.parentElement && first.parentElement && !first.closest('[data-btc-track]')) {
            first.parentElement.insertBefore(wrap, first);
          }

          var track = wrap.querySelector('[data-btc-track]');
          items.forEach(function (el) { if (el.parentElement !== track) track.appendChild(el); });
          updateNav(wrap);
        }

        function schedule() {
          clearTimeout(buildT);
          buildT = setTimeout(build, 60);
        }

        window.addEventListener('resize', function () {
          clearTimeout(buildT);
          buildT = setTimeout(build, 250);
        });
        window.addEventListener('load', schedule);
        return { schedule: schedule, build: build };
      })();
    }

    function bind(el) {
      if (!el || el.__bguReady) return;
      el.__bguReady = true;
      moveBlock(el);
      syncMediaSize(el);
      setTimeout(function () { syncMediaSize(el); }, 500);
      setTimeout(function () { syncMediaSize(el); }, 1500);
      loadPrice(el);
    }

    document.querySelectorAll('[data-bt-figupsell]').forEach(bind);
    window.__btUpsellCarousel.schedule();
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-figupsell]').forEach(bind);
    });
    document.addEventListener('shopify:section:load', function () {
      stampOrders();
      document.querySelectorAll('[data-bt-figupsell]').forEach(bind);
      window.__btUpsellCarousel.schedule();
    });

    /* Кошик morph-иться при видаленні/зміні кількості БЕЗ перезавантаження —
       свіжі елементи блока треба заново привʼязати (телепорт, карусель,
       ціни), інакше апсели вискакують угору «сирими». Детектор у
       MutationObserver дивиться на НЕзаштамповані елементи, тож наші власні
       переміщення (вони вже з data-tp-order) ребайнд не тригерять. */
    var rebindT;
    function scheduleRebind() {
      clearTimeout(rebindT);
      rebindT = setTimeout(function () {
        stampOrders();
        document.querySelectorAll('[data-bt-figupsell]').forEach(bind);
        window.__btUpsellCarousel.schedule();
      }, 120);
    }
    document.addEventListener('cart:refresh', scheduleRebind);
    document.addEventListener('cart:updated', scheduleRebind);
    document.addEventListener('bricktopia:production-updated', scheduleRebind);
    new MutationObserver(function () {
      if (document.querySelector('[data-bt-figupsell]:not([data-tp-order])')) scheduleRebind();
    }).observe(document.body, { childList: true, subtree: true });

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        document.querySelectorAll('[data-bt-figupsell]').forEach(function (el) {
          moveBlock(el);
          syncMediaSize(el);
        });
      }, 200);
    });
    window.addEventListener('load', function () {
      document.querySelectorAll('[data-bt-figupsell]').forEach(syncMediaSize);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-frame-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    /* --- Position teleport (той самий патерн, що cart-upsell) --- */

    /* Порядок телепортнутих блоків = порядок блоків у кастомайзері
       (див. коментар у cart-upsell.liquid). */
    var TP_SELECTOR = '[data-cart-fast-delivery],[data-bt-upsell],[data-bt-fupsell],[data-bt-figupsell],[data-bt-updivider]';
    /* Номер порядку беремо з позиції рідної обгортки <shopify-block> серед
       усіх обгорток: вони лишаються на місці після телепорту, тож і після
       ре-рендера секції в редакторі порядок рахується правильно (старий
       one-shot штамп давав новоствореним елементам 999 → блок падав у кінець
       списку, звідси «на ПК порядок не відповідає»). */
    function stampOrders() {
      /* Морф кошика ре-рендерить блок у рідній обгортці, а СТАРА
         телепортнута копія (вона живе вже ПОЗА обгорткою) морфом не
         зноситься → блок дублювався після кожної зміни кошика. Лишаємо
         свіжу копію (ту, що в обгортці), старі прибираємо. */
      var dupGroups = {};
      document.querySelectorAll('[data-bt-block-id]').forEach(function (n) {
        var bid = n.getAttribute('data-bt-block-id');
        (dupGroups[bid] = dupGroups[bid] || []).push(n);
      });
      Object.keys(dupGroups).forEach(function (bid) {
        var list = dupGroups[bid];
        if (list.length < 2) return;
        var keep = null;
        for (var d = 0; d < list.length; d++) {
          if (list[d].closest('shopify-block, .shopify-block')) { keep = list[d]; break; }
        }
        if (!keep) keep = list[0];
        list.forEach(function (n) { if (n !== keep) n.remove(); });
      });

      var wrappers = Array.prototype.slice.call(document.querySelectorAll('shopify-block, .shopify-block'));
      document.querySelectorAll(TP_SELECTOR).forEach(function (n, i) {
        if (!n.__btOrigWrap || !n.__btOrigWrap.isConnected) {
          var w = n.closest('shopify-block, .shopify-block');
          if (w) n.__btOrigWrap = w;
        }
        var idx = n.__btOrigWrap ? wrappers.indexOf(n.__btOrigWrap) : -1;
        n.setAttribute('data-tp-order', idx >= 0 ? idx : 500 + i);
      });
    }
    stampOrders();
    function insertOrdered(target, el) {
      var mine = parseInt(el.getAttribute('data-tp-order') || '999', 10);
      var before = null;
      for (var i = 0; i < target.children.length; i++) {
        var c = target.children[i];
        if (c === el || !c.getAttribute) continue;
        var o = c.getAttribute('data-tp-order');
        if (o !== null && parseInt(o, 10) > mine) { before = c; break; }
      }
      if (before) target.insertBefore(el, before); else target.appendChild(el);
    }

    function findTarget(pos) {
      if (pos === 'under-summary') {
        return document.querySelector('.cart__summary-container')
            || document.querySelector('[data-cart-summary]')
            || (document.querySelector('.cart__summary-totals') && document.querySelector('.cart__summary-totals').parentElement);
      }
      if (pos === 'under-products') {
        return (document.querySelector('.cart-items__table') && document.querySelector('.cart-items__table').parentElement)
            || document.querySelector('cart-items-component')
            || document.querySelector('.cart-items')
            || document.querySelector('#cart-form');
      }
      return null;
    }
    function moveBlock(el) {
      /* Учасників каруселі рухає сам карусельний модуль (обгорткою). */
      if (el.closest('[data-btc-track]')) return;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var pos = isMobile ? (el.dataset.posMobile || 'default') : (el.dataset.posDesktop || 'default');
      if (pos === 'default') {
        if (el.__bfuOrigParent && el.parentElement !== el.__bfuOrigParent) el.__bfuOrigParent.appendChild(el);
        return;
      }
      if (!el.__bfuOrigParent) el.__bfuOrigParent = el.parentElement;
      var target = findTarget(pos);
      if (target) insertOrdered(target, el);
    }

    /* --- Карусель апселів (спільний модуль — ідентичний код і window-guard
       живуть також у cart-upsell.liquid; виконується перший з двох). --- */
    if (!window.__btUpsellCarousel) {
      window.__btUpsellCarousel = (function () {
        var buildT = null;

        function isMobileMQ() { return window.matchMedia('(max-width: 749px)').matches; }
        function posOf(el) { return isMobileMQ() ? (el.dataset.posMobile || 'default') : (el.dataset.posDesktop || 'default'); }

        function visibleItems() {
          return Array.prototype.slice.call(document.querySelectorAll('[data-bt-carousel="1"]'))
            .filter(function (el) { return el.style.display !== 'none'; })
            .sort(function (a, b) {
              return parseInt(a.getAttribute('data-tp-order') || '999', 10)
                   - parseInt(b.getAttribute('data-tp-order') || '999', 10);
            });
        }

        function slides(wrap) {
          var track = wrap.querySelector('[data-btc-track]');
          return Array.prototype.filter.call(track.children, function (c) {
            return getComputedStyle(c).display !== 'none';
          });
        }

        /* Крок прокрутки = реальна ширина слайда + gap треку. На мобілці
           слайд вужчий за трек (peek наступної картки), тож clientWidth
           треку більше не годиться. */
        function slideStep(wrap) {
          var track = wrap.querySelector('[data-btc-track]');
          var sl = slides(wrap);
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return sl.length ? sl[0].getBoundingClientRect().width + gap : (track.clientWidth || 1);
        }

        function updateNav(wrap) {
          var sl = slides(wrap);
          var track = wrap.querySelector('[data-btc-track]');
          var dots = wrap.querySelector('[data-btc-dots]');
          wrap.classList.toggle('bt-upsell-carousel--single', sl.length < 2);
          var step = slideStep(wrap);
          var idx = step ? Math.round(track.scrollLeft / step) : 0;
          var html = '';
          for (var i = 0; i < sl.length; i++) {
            html += '<button type="button" class="bt-upsell-carousel__dot' + (i === idx ? ' is-active' : '') + '" data-btc-dot="' + i + '" aria-label="' + (i + 1) + '"></button>';
          }
          dots.innerHTML = html;
        }

        /* Власна rAF-анімація скролу: нативний smooth-scrollTo на цьому
           треку глушиться (scroll-snap + тема), пряме присвоєння працює. */
        function animateTo(track, left) {
          var start = track.scrollLeft;
          var delta = left - start;
          if (!delta) return;
          track.__btcAnim = (track.__btcAnim || 0) + 1;
          var myAnim = track.__btcAnim;
          var dur = 320;
          var t0 = null;
          track.style.scrollSnapType = 'none';
          var ticked = false;
          function stepFn(ts) {
            if (track.__btcAnim !== myAnim) return; /* перебито новою анімацією */
            ticked = true;
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / dur);
            var e = 1 - Math.pow(1 - p, 3); /* easeOutCubic */
            track.scrollLeft = start + delta * e;
            if (p < 1) requestAnimationFrame(stepFn);
            else track.style.scrollSnapType = '';
          }
          requestAnimationFrame(stepFn);
          /* rAF не тікає у фонових/прихованих вкладках — тоді стрибаємо
             одразу, щоб клік по стрілці не «з'їдався». */
          setTimeout(function () {
            if (!ticked && track.__btcAnim === myAnim) {
              track.scrollLeft = left;
              track.style.scrollSnapType = '';
            }
          }, 120);
        }
        function goTo(wrap, idx) {
          var track = wrap.querySelector('[data-btc-track]');
          var count = slides(wrap).length;
          if (idx < 0) idx = count - 1;
          if (idx >= count) idx = 0;
          animateTo(track, idx * slideStep(wrap));
        }

        function bindNav(wrap) {
          var track = wrap.querySelector('[data-btc-track]');
          wrap.addEventListener('click', function (e) {
            var t = e.target;
            if (t.hasAttribute('data-btc-prev')) goTo(wrap, Math.round(track.scrollLeft / slideStep(wrap)) - 1);
            else if (t.hasAttribute('data-btc-next')) goTo(wrap, Math.round(track.scrollLeft / slideStep(wrap)) + 1);
            else if (t.hasAttribute('data-btc-dot')) goTo(wrap, parseInt(t.getAttribute('data-btc-dot'), 10));
          });
          var st;
          track.addEventListener('scroll', function () {
            clearTimeout(st);
            st = setTimeout(function () { updateNav(wrap); }, 80);
          });
        }

        function build() {
          var items = visibleItems();
          var wrap = document.querySelector('[data-bt-upsell-carousel]');
          if (items.length < 2) {
            if (wrap) {
              var track0 = wrap.querySelector('[data-btc-track]');
              while (track0.firstChild) wrap.parentElement.insertBefore(track0.firstChild, wrap);
              wrap.remove();
            }
            return;
          }
          if (!wrap) {
            wrap = document.createElement('div');
            wrap.className = 'bt-upsell-carousel';
            wrap.setAttribute('data-bt-upsell-carousel', '');
            wrap.innerHTML =
              '<div class="bt-upsell-carousel__track" data-btc-track></div>' +
              '<button type="button" class="bt-upsell-carousel__arrow bt-upsell-carousel__arrow--prev" data-btc-prev aria-label="Prev">&#8249;</button>' +
              '<button type="button" class="bt-upsell-carousel__arrow bt-upsell-carousel__arrow--next" data-btc-next aria-label="Next">&#8250;</button>' +
              '<div class="bt-upsell-carousel__dots" data-btc-dots></div>';
            bindNav(wrap);
          }

          var first = items[0];
          wrap.dataset.posDesktop = first.dataset.posDesktop || 'default';
          wrap.dataset.posMobile = first.dataset.posMobile || 'default';
          wrap.setAttribute('data-tp-order', first.getAttribute('data-tp-order') || '0');

          var pos = posOf(first);
          if (pos === 'default') {
            var orig = first.__btUpsellOrigParent || first.__bfuOrigParent || first.__bguOrigParent || null;
            var anchor = orig || (!first.closest('[data-btc-track]') ? first.parentElement : null);
            if (anchor && wrap.parentElement !== anchor) anchor.appendChild(wrap);
          } else {
            var target = findTarget(pos);
            if (target) insertOrdered(target, wrap);
          }
          if (!wrap.parentElement && first.parentElement && !first.closest('[data-btc-track]')) {
            first.parentElement.insertBefore(wrap, first);
          }

          var track = wrap.querySelector('[data-btc-track]');
          items.forEach(function (el) { if (el.parentElement !== track) track.appendChild(el); });
          updateNav(wrap);
        }

        function schedule() {
          clearTimeout(buildT);
          buildT = setTimeout(build, 60);
        }

        window.addEventListener('resize', function () {
          clearTimeout(buildT);
          buildT = setTimeout(build, 250);
        });
        window.addEventListener('load', schedule);
        return { schedule: schedule, build: build };
      })();
    }

    /* --- Auto-size картинки під мініатюри товарів кошика --- */
    function syncMediaSize(el) {
      if (el.dataset.matchCartMedia !== '1') return;
      var ref = document.querySelector('.cart-items__media-container')
             || document.querySelector('.cart-items__media img')
             || document.querySelector('.cart-items__media');
      if (!ref) return;
      var r = ref.getBoundingClientRect();
      if (r.width < 20 || r.height < 20) return;
      var size = Math.round(Math.min(r.width, r.height));
      el.style.setProperty('--bt-fupsell-media', size + 'px');
      el.style.setProperty('--bt-fupsell-media-mobile', size + 'px');
      var br = getComputedStyle(ref).borderRadius;
      if (br && br !== '0px') el.style.setProperty('--bt-fupsell-media-radius', br);
    }

    function formatPrice(n, label) {
      var B = window.BtPriceConvert;
      if (B && B.active) return B.format(n) + ' ' + B.symbol;
      var rounded = Math.round(n);
      var s = String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return label ? s + ' ' + label : s;
    }

    /* --- Ціна з API конструктора рамок --- */
    function loadPrice(el) {
      var url = el.dataset.apiUrl;
      if (!url) return;
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        if (!d || !d.success) throw new Error('frame-upsell API: bad response');
        var mode = el.dataset.priceMode || 'diff';
        var figureCents = parseInt(el.dataset.figurePriceCents, 10) || 0;
        var figureInCart = figureCents / 100;
        /* API віддає ціни у валюті магазину, а фігурка в кошику вже у валюті
           покупця. На іншому ринку (ЄС, США, Канада) спершу переводимо ціни API
           так, як це зробить Shopify (курс + надбавка ринку + округлення). */
        var BPC = window.BtPriceConvert, CONV = !!(BPC && BPC.active);
        if (CONV) d = { framePrice: BPC.amount(d.framePrice), total: BPC.amount(d.total), currency: BPC.symbol };
        var price;
        if (mode === 'frame_only') price = d.framePrice;
        else if (mode === 'total') price = d.total;
        else price = d.total - figureInCart; /* diff: доплата понад фігурку в кошику */
        if (!(price > 0)) price = d.framePrice; /* захист від від'ємної доплати */
        var label = CONV ? BPC.symbol : (el.dataset.currencyLabel || d.currency || '');
        var tpl = el.dataset.priceTemplate || '{price}';
        var text = tpl
          .replace('{price}', formatPrice(price, label))
          .replace('{total}', formatPrice(d.total, label));
        var priceEl = el.querySelector('[data-bfu-price]');
        if (priceEl) { priceEl.textContent = text; priceEl.hidden = false; }
        console.log('🖼 Frame upsell price:', { mode: mode, api: d, figureInCart: figureInCart, shown: price });
      }).catch(function (err) {
        console.error('🖼 Frame upsell price failed:', err);
        /* Без ціни меседж неповний — ховаємо блок (крім редактора тем). */
        if (el.dataset.designMode !== '1') {
          el.style.display = 'none';
          /* Якщо блок був у каруселі — перебудувати крапки/слайди. */
          if (window.__btUpsellCarousel) window.__btUpsellCarousel.schedule();
        }
      });
    }

    function bind(el) {
      if (!el || el.__bfuReady) return;
      el.__bfuReady = true;
      moveBlock(el);
      syncMediaSize(el);
      setTimeout(function () { syncMediaSize(el); }, 500);
      setTimeout(function () { syncMediaSize(el); }, 1500);
      loadPrice(el);
    }

    document.querySelectorAll('[data-bt-fupsell]').forEach(bind);
    window.__btUpsellCarousel.schedule();
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-fupsell]').forEach(bind);
    });
    document.addEventListener('shopify:section:load', function () {
      stampOrders();
      document.querySelectorAll('[data-bt-fupsell]').forEach(bind);
      window.__btUpsellCarousel.schedule();
    });

    /* Кошик morph-иться при видаленні/зміні кількості БЕЗ перезавантаження —
       свіжі елементи блока треба заново привʼязати (телепорт, карусель,
       ціни), інакше апсели вискакують угору «сирими». Детектор у
       MutationObserver дивиться на НЕзаштамповані елементи, тож наші власні
       переміщення (вони вже з data-tp-order) ребайнд не тригерять. */
    var rebindT;
    function scheduleRebind() {
      clearTimeout(rebindT);
      rebindT = setTimeout(function () {
        stampOrders();
        document.querySelectorAll('[data-bt-fupsell]').forEach(bind);
        window.__btUpsellCarousel.schedule();
      }, 120);
    }
    document.addEventListener('cart:refresh', scheduleRebind);
    document.addEventListener('cart:updated', scheduleRebind);
    document.addEventListener('bricktopia:production-updated', scheduleRebind);
    new MutationObserver(function () {
      if (document.querySelector('[data-bt-fupsell]:not([data-tp-order])')) scheduleRebind();
    }).observe(document.body, { childList: true, subtree: true });

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        document.querySelectorAll('[data-bt-fupsell]').forEach(function (el) {
          moveBlock(el);
          syncMediaSize(el);
        });
      }, 200);
    });
    window.addEventListener('load', function () {
      document.querySelectorAll('[data-bt-fupsell]').forEach(syncMediaSize);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-gift"] && !Shopify.designMode) return;
  try {
    /* Cart gift block — independent per-instance handler. Watches for cart
     changes so it can hide when the upsell product is already in cart
     (so user doesn't add 2x), or when the cart is empty / still in
     "checking parts" state. Click adds the configured variant via
     /cart/add.js with line-item properties matching the legacy heart
     upsell so HeartKeychainUpsellSystem detects it correctly. */
  (function () {
    var blocks = document.querySelectorAll('[data-cart-gift]');
    if (!blocks.length) return;

    function isUpsellInCart(cart, variantId) {
      if (!cart || !Array.isArray(cart.items)) return false;
      var vid = parseInt(variantId, 10);
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === vid) return true;
      }
      return false;
    }

    function getProductionInfoSafe() {
      try {
        if (window.heartUpsellSystem && typeof window.heartUpsellSystem.fastDeliverySystem !== 'undefined') {
          return window.heartUpsellSystem.fastDeliverySystem.getProductionInfo();
        }
        if (window.cartSystems && window.cartSystems.fastDeliverySystem) {
          return window.cartSystems.fastDeliverySystem.getProductionInfo();
        }
      } catch (_) {}
      return null;
    }

    function refreshVisibility(el) {
      var hideIfInCart = el.dataset.cartGiftHideIfInCart === '1';
      var hideWhenEmpty = el.dataset.cartGiftHideWhenEmpty === '1';
      var hideWhenProcessing = el.dataset.cartGiftHideWhenProcessing === '1';
      var variantId = el.dataset.cartGiftVariant;

      var cart = window.BricktopiaCart_data || (window.BricktopiaCart && window.BricktopiaCart.cart);
      /* No cart yet → keep invisible (no is-ready, no is-hidden).
         Block stays at opacity:0 until we have data to make a real decision. */
      if (!cart) return;

      var hide = false;
      if (hideWhenEmpty && (!cart.items || cart.items.length === 0)) hide = true;
      if (!hide && hideIfInCart && isUpsellInCart(cart, variantId)) hide = true;
      if (!hide && hideWhenProcessing) {
        var pi = getProductionInfoSafe();
        /* Still checking parts? Don't make a decision yet — leave the
           block invisible. This stops the "appear → disappear → re-appear"
           dance the user complained about. */
        if (pi && pi.checking) return;
        if (pi && pi.hasWaiting) hide = true;
      }

      if (hide) {
        el.classList.add('is-hidden');
        el.classList.remove('is-ready');
      } else {
        el.classList.remove('is-hidden');
        el.classList.add('is-ready');
      }
    }

    /* Position teleport — move the block under cart summary or under
       products list based on the per-viewport setting. Default = leave
       wherever it was placed in the section. We remember the original
       parent so we can swap back when the merchant flips the setting. */
    function findTarget(pos) {
      if (pos === 'under-summary') {
        return document.querySelector('.cart__summary-container')
            || document.querySelector('[data-cart-summary]')
            || (document.querySelector('.cart__summary-totals') && document.querySelector('.cart__summary-totals').parentElement);
      }
      if (pos === 'under-products') {
        return (document.querySelector('.cart-items__table') && document.querySelector('.cart-items__table').parentElement)
            || document.querySelector('cart-items-component')
            || document.querySelector('.cart-items')
            || document.querySelector('#cart-form');
      }
      return null;
    }
    function moveBlock(el) {
      var posDesktop = el.dataset.posDesktop || 'default';
      var posMobile = el.dataset.posMobile || 'default';
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var pos = isMobile ? posMobile : posDesktop;
      if (pos === 'default') {
        /* Restore to original parent if we previously moved it. */
        if (el.__cgOrigParent && el.parentElement !== el.__cgOrigParent) {
          el.__cgOrigParent.appendChild(el);
        }
        return;
      }
      if (!el.__cgOrigParent) el.__cgOrigParent = el.parentElement;
      var target = findTarget(pos);
      if (target && target !== el.parentElement) {
        target.appendChild(el);
      }
    }

    function bindBlock(el) {
      if (el.__cartGiftReady) return;
      el.__cartGiftReady = true;
      moveBlock(el);

      var btn = el.querySelector('[data-cart-gift-add]');
      var labelEl = el.querySelector('.cart-gift-block__btn-label');
      var addedText = el.dataset.cartGiftAddedText || '✓';

      if (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          btn.disabled = true;
          var variantId = parseInt(el.dataset.cartGiftVariant, 10);
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1,
                /* These properties are checked by HeartKeychainUpsellSystem
                   to decide whether to hide the inline gift block — keep
                   them in sync. */
                properties: { '_upsell': true, '_heart_keychain_upsell': true, '_gift_upsell': true }
              }]
            })
          }).then(function (r) {
            if (!r.ok) throw new Error('Cart add failed: ' + r.status);
            return r.json();
          }).then(function () {
            el.classList.add('is-added');
            if (labelEl) labelEl.textContent = addedText;
            try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'cart-gift' } })); } catch (_) {}
            /* Hard reload — most reliable way to refresh all cart UI
               (totals, line items, hidden upsell logic). */
            setTimeout(function () { window.location.reload(); }, 300);
          }).catch(function (err) {
            console.error('[cart-gift] Add error:', err);
            btn.disabled = false;
          });
        });
      }

      refreshVisibility(el);
    }

    blocks.forEach(bindBlock);

    /* Re-evaluate visibility whenever cart updates so the block hides
       once the user adds the heart keychain elsewhere or empties cart. */
    var rerun = function () { blocks.forEach(refreshVisibility); };
    document.addEventListener('cart:refresh', rerun);
    document.addEventListener('bricktopia:production-updated', rerun);
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target) e.target.querySelectorAll('[data-cart-gift]').forEach(bindBlock);
    });
    /* Also re-check periodically in case BricktopiaCart_data updates
       without firing an event we listen to. */
    setInterval(rerun, 2500);

    /* Re-position on resize (e.g. phone rotation) — debounced. The
       desktop/mobile breakpoint is `(max-width: 749px)`. */
    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () { blocks.forEach(moveBlock); }, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-guarantee"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cartGuaranteeReady) return;
    window.__cartGuaranteeReady = true;

    function findTarget(pos) {
      if (pos === 'under-summary') {
        return document.querySelector('.cart__summary-container')
            || document.querySelector('[data-cart-summary]')
            || (document.querySelector('.cart__summary-totals') && document.querySelector('.cart__summary-totals').parentElement);
      }
      if (pos === 'over-summary') {
        /* Same container as under-summary but we INSERT before the first
           child instead of appending. */
        return document.querySelector('.cart__summary-container')
            || document.querySelector('[data-cart-summary]')
            || (document.querySelector('.cart__summary-totals') && document.querySelector('.cart__summary-totals').parentElement);
      }
      if (pos === 'under-products') {
        return (document.querySelector('.cart-items__table') && document.querySelector('.cart-items__table').parentElement)
            || document.querySelector('cart-items-component')
            || document.querySelector('.cart-items')
            || document.querySelector('#cart-form');
      }
      return null;
    }

    function moveBlock(el) {
      var posDesktop = el.dataset.posDesktop || 'default';
      var posMobile = el.dataset.posMobile || 'default';
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var pos = isMobile ? posMobile : posDesktop;
      if (pos === 'default') {
        if (el.__cgOrigParent && el.parentElement !== el.__cgOrigParent) {
          el.__cgOrigParent.appendChild(el);
        }
        return;
      }
      if (!el.__cgOrigParent) el.__cgOrigParent = el.parentElement;
      var target = findTarget(pos);
      if (!target) return;
      /* On desktop with under-summary: place AFTER cart-reviews if it's in
         the same container, so the merchant gets «reviews → guarantee»
         order. On mobile or other positions, fall back to default behavior. */
      if (pos === 'under-summary' && !isMobile) {
        var reviews = target.querySelector(':scope > [data-cart-reviews]');
        if (reviews) {
          if (el !== reviews.nextElementSibling) {
            reviews.insertAdjacentElement('afterend', el);
          }
          return;
        }
        if (target !== el.parentElement) target.appendChild(el);
        return;
      }
      if (target === el.parentElement) return;
      if (pos === 'over-summary') {
        target.insertBefore(el, target.firstChild);
      } else {
        target.appendChild(el);
      }
    }

    /* Чи є в кошику товар З КОНСТРУКТОРА (mini/frame/pet/baby/bundle) —
       такі мають JSON-конфіг і потрапляють у BricktopiaCart.itemStates.
       Голі деталі поштучно конфігу не мають → itemStates порожній. */
    function hasConstructorItem() {
      var bc = window.BricktopiaCart;
      return !!(bc && bc.itemStates && Object.keys(bc.itemStates).length > 0);
    }

    function reveal(el) {
      /* У редакторі тем показуємо завжди — щоб було що налаштовувати. */
      if (window.Shopify && window.Shopify.designMode) {
        el.style.display = '';
        el.classList.add('is-ready');
        return;
      }
      var hideWhenEmpty = el.dataset.hideWhenEmpty === '1';
      var onlyConstructor = el.dataset.onlyConstructor === '1';
      var cart = window.BricktopiaCart_data || (window.BricktopiaCart && window.BricktopiaCart.cart);
      if (hideWhenEmpty) {
        if (!cart) return; /* wait — we'll be re-called when cart loads */
        if (!cart.items || cart.items.length === 0) {
          el.style.display = 'none';
          return;
        }
      }
      /* Ховаємо, коли в кошику самі деталі без жодного конструкторного
         товару. Перевіряється заново на кожен production-updated /
         cart:morphed — стан перемикається в обидва боки. */
      if (onlyConstructor && !hasConstructorItem()) {
        el.style.display = 'none';
        return;
      }
      el.style.display = '';
      el.classList.add('is-ready');
    }

    function bindBlock(el) {
      if (!el.__cgGuaranteeReady) {
        el.__cgGuaranteeReady = true;
        moveBlock(el);
      }
      /* reveal ганяємо щоразу — видимість залежить від складу кошика,
         який змінюється без перезавантаження. */
      reveal(el);
    }

    function init() {
      document.querySelectorAll('[data-cart-guarantee]').forEach(bindBlock);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    /* Re-position on viewport change so user can rotate the device. */
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-cart-guarantee]').forEach(function (el) {
        moveBlock(el);
      });
    });
    /* Re-bind after AJAX cart updates morph the DOM. */
    document.addEventListener('bricktopia:production-updated', init);
    document.addEventListener('cart:morphed', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cartReviewsReady) return;
    window.__cartReviewsReady = true;

    function findTarget(pos) {
      if (pos === 'under-summary' || pos === 'over-summary') {
        return document.querySelector('.cart__summary-container')
            || document.querySelector('[data-cart-summary]')
            || (document.querySelector('.cart__summary-totals') && document.querySelector('.cart__summary-totals').parentElement);
      }
      if (pos === 'under-products') {
        return (document.querySelector('.cart-items__table') && document.querySelector('.cart-items__table').parentElement)
            || document.querySelector('cart-items-component')
            || document.querySelector('.cart-items')
            || document.querySelector('#cart-form');
      }
      return null;
    }

    function moveBlock(el) {
      var posDesktop = el.dataset.posDesktop || 'default';
      var posMobile = el.dataset.posMobile || 'default';
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var pos = isMobile ? posMobile : posDesktop;
      if (pos === 'default') {
        if (el.__crvOrigParent && el.parentElement !== el.__crvOrigParent) {
          el.__crvOrigParent.appendChild(el);
        }
        return;
      }
      if (!el.__crvOrigParent) el.__crvOrigParent = el.parentElement;
      var target = findTarget(pos);
      if (!target) return;
      /* On desktop with under-summary: enforce «reviews FIRST, guarantee
         AFTER» order. If a guarantee block is already in the same target,
         insert reviews BEFORE it. */
      if (pos === 'under-summary' && !isMobile) {
        var guarantee = target.querySelector(':scope > [data-cart-guarantee]');
        if (guarantee) {
          if (el !== guarantee.previousElementSibling) {
            target.insertBefore(el, guarantee);
          }
          return;
        }
        if (target !== el.parentElement) target.appendChild(el);
        return;
      }
      if (target === el.parentElement) return;
      if (pos === 'over-summary') {
        target.insertBefore(el, target.firstChild);
      } else {
        target.appendChild(el);
      }
    }

    function maybeHideEmpty(el) {
      var hide = el.dataset.hideWhenEmpty === '1';
      if (!hide) return false;
      var cart = window.BricktopiaCart_data || (window.BricktopiaCart && window.BricktopiaCart.cart);
      if (!cart) return true;
      if (!cart.items || cart.items.length === 0) {
        el.style.display = 'none';
        return true;
      }
      return false;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function fetchAndRender(el) {
      var apiBase = el.dataset.apiBase;
      var storeId = el.dataset.storeId;
      var ratingOffset = parseFloat(el.dataset.ratingOffset) || 0;
      var ratingMin = parseFloat(el.dataset.ratingMin);
      if (isNaN(ratingMin)) ratingMin = 4.0;
      var ctaText = el.dataset.ctaText || '';
      var ctaUrl = el.dataset.ctaUrl || '';
      var ctaIcon = el.dataset.ctaIcon || '';
      var reviewsSuffix = el.dataset.reviewsSuffix || '';
      var starsMode = el.dataset.starsMode || 'five';

      var url = apiBase + '/api/public/reviews/summary?storeId=' + encodeURIComponent(storeId);
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        if (!data || !data.success || !data.count) {
          el.style.display = 'none';
          return;
        }
        var avg = (typeof data.average === 'number' ? data.average : parseFloat(data.average)) + ratingOffset;
        if (avg < ratingMin) avg = ratingMin;
        if (avg > 5) avg = 5;
        var ratingDisplay = (Math.round(avg * 10) / 10).toFixed(1);

        /* Stars: «five» → ★★★★★ (filled to rounded), «one» → single ★ */
        var stars;
        var starsClass = 'cart-rev-' + el.id + '__stars';
        if (starsMode === 'one') {
          stars = '★';
          starsClass += ' cart-rev-' + el.id + '__stars--one';
        } else {
          stars = '';
          var rounded = Math.round(avg);
          for (var i = 1; i <= 5; i++) stars += (i <= rounded ? '★' : '☆');
        }

        /* Row 1 — stars + rating + count, all inline */
        var line1 = '<span class="cart-rev-' + el.id + '__line">'
                  + '<span class="' + starsClass + '" aria-hidden="true">' + stars + '</span>'
                  + '<span class="cart-rev-' + el.id + '__rating">' + ratingDisplay + '</span>'
                  + '<span class="cart-rev-' + el.id + '__count">· ' + data.count + ' ' + escapeHtml(reviewsSuffix) + '</span>'
                  + '</span>';

        /* Row 2 — CTA on its own line below */
        var line2 = '';
        if (ctaText && ctaUrl) {
          line2 = '<a class="cart-rev-' + el.id + '__cta" href="' + escapeHtml(ctaUrl) + '" target="_blank" rel="noopener">';
          if (ctaIcon) line2 += '<span class="cart-rev-' + el.id + '__cta-icon" aria-hidden="true">' + escapeHtml(ctaIcon) + '</span>';
          line2 += escapeHtml(ctaText);
          line2 += '</a>';
        }

        el.innerHTML = line1 + line2;
        el.classList.add('is-ready');
      }).catch(function () {
        el.style.display = 'none';
      });
    }

    function bindBlock(el) {
      if (el.__cartReviewsReady) return;
      el.__cartReviewsReady = true;
      var match = (el.className || '').match(/cart-rev-([a-z0-9]+)/);
      el.id = match ? match[1] : '';
      moveBlock(el);
      if (maybeHideEmpty(el)) return;
      fetchAndRender(el);
    }

    function init() {
      document.querySelectorAll('[data-cart-reviews]').forEach(bindBlock);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-cart-reviews]').forEach(moveBlock);
    });
    document.addEventListener('bricktopia:production-updated', init);
    document.addEventListener('cart:morphed', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-upsell-custom"] && !Shopify.designMode) return;
  try {
    /* Same per-instance handler as cart-gift.liquid — works on every
     [data-cart-gift] element regardless of which block file emitted it.
     Idempotent thanks to `__cartGiftReady`. */
  (function () {
    var blocks = document.querySelectorAll('[data-cart-gift]');
    if (!blocks.length) return;

    function isUpsellInCart(cart, variantId) {
      if (!cart || !Array.isArray(cart.items)) return false;
      var vid = parseInt(variantId, 10);
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === vid) return true;
      }
      return false;
    }
    function getProductionInfoSafe() {
      try {
        if (window.heartUpsellSystem && typeof window.heartUpsellSystem.fastDeliverySystem !== 'undefined') {
          return window.heartUpsellSystem.fastDeliverySystem.getProductionInfo();
        }
        if (window.cartSystems && window.cartSystems.fastDeliverySystem) {
          return window.cartSystems.fastDeliverySystem.getProductionInfo();
        }
      } catch (_) {}
      return null;
    }
    function refreshVisibility(el) {
      var hideIfInCart = el.dataset.cartGiftHideIfInCart === '1';
      var hideWhenEmpty = el.dataset.cartGiftHideWhenEmpty === '1';
      var hideWhenProcessing = el.dataset.cartGiftHideWhenProcessing === '1';
      var variantId = el.dataset.cartGiftVariant;
      var cart = window.BricktopiaCart_data || (window.BricktopiaCart && window.BricktopiaCart.cart);
      if (!cart) return;
      var hide = false;
      if (hideWhenEmpty && (!cart.items || cart.items.length === 0)) hide = true;
      if (!hide && hideIfInCart && isUpsellInCart(cart, variantId)) hide = true;
      if (!hide && hideWhenProcessing) {
        var pi = getProductionInfoSafe();
        if (pi && pi.checking) return;
        if (pi && pi.hasWaiting) hide = true;
      }
      if (hide) { el.classList.add('is-hidden'); el.classList.remove('is-ready'); }
      else { el.classList.remove('is-hidden'); el.classList.add('is-ready'); }
    }
    function findTarget(pos) {
      if (pos === 'under-summary') {
        return document.querySelector('.cart__summary-container')
            || document.querySelector('[data-cart-summary]')
            || (document.querySelector('.cart__summary-totals') && document.querySelector('.cart__summary-totals').parentElement);
      }
      if (pos === 'under-products') {
        return (document.querySelector('.cart-items__table') && document.querySelector('.cart-items__table').parentElement)
            || document.querySelector('cart-items-component')
            || document.querySelector('.cart-items')
            || document.querySelector('#cart-form');
      }
      return null;
    }
    function moveBlock(el) {
      var posDesktop = el.dataset.posDesktop || 'default';
      var posMobile = el.dataset.posMobile || 'default';
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var pos = isMobile ? posMobile : posDesktop;
      if (pos === 'default') {
        if (el.__cgOrigParent && el.parentElement !== el.__cgOrigParent) el.__cgOrigParent.appendChild(el);
        return;
      }
      if (!el.__cgOrigParent) el.__cgOrigParent = el.parentElement;
      var target = findTarget(pos);
      if (target && target !== el.parentElement) target.appendChild(el);
    }
    function bindBlock(el) {
      if (el.__cartGiftReady) return;
      el.__cartGiftReady = true;
      moveBlock(el);
      var btn = el.querySelector('[data-cart-gift-add]');
      var labelEl = el.querySelector('.cart-gift-block__btn-label');
      if (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          btn.disabled = true;
          var variantId = parseInt(el.dataset.cartGiftVariant, 10);
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1,
                properties: { '_upsell': true, '_custom_upsell': true }
              }]
            })
          }).then(function (r) {
            if (!r.ok) throw new Error('Cart add failed: ' + r.status);
            return r.json();
          }).then(function () {
            el.classList.add('is-added');
            if (labelEl) labelEl.textContent = '✓';
            try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'cart-upsell-custom' } })); } catch (_) {}
            setTimeout(function () { window.location.reload(); }, 300);
          }).catch(function (err) {
            console.error('[cart-upsell-custom] Add error:', err);
            btn.disabled = false;
          });
        });
      }
      refreshVisibility(el);
    }
    blocks.forEach(bindBlock);
    var rerun = function () { blocks.forEach(refreshVisibility); };
    document.addEventListener('cart:refresh', rerun);
    document.addEventListener('bricktopia:production-updated', rerun);
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target) e.target.querySelectorAll('[data-cart-gift]').forEach(bindBlock);
    });
    setInterval(rerun, 2500);
    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () { blocks.forEach(moveBlock); }, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-upsell-divider"] && !Shopify.designMode) return;
  try {
    (function () {
    var TP_SELECTOR = '[data-cart-fast-delivery],[data-bt-upsell],[data-bt-fupsell],[data-bt-figupsell],[data-bt-updivider]';
    /* Порядок телепорту = порядок блоків у кастомайзері. Номер беремо з
       позиції рідної обгортки <shopify-block> серед усіх обгорток: вони
       лишаються на місці після телепорту, тож і після ре-рендера секції
       в редакторі порядок рахується правильно. */
    function stampOrders() {
      /* Морф кошика ре-рендерить блок у рідній обгортці, а СТАРА
         телепортнута копія (вона живе вже ПОЗА обгорткою) морфом не
         зноситься → блок дублювався після кожної зміни кошика. Лишаємо
         свіжу копію (ту, що в обгортці), старі прибираємо. */
      var dupGroups = {};
      document.querySelectorAll('[data-bt-block-id]').forEach(function (n) {
        var bid = n.getAttribute('data-bt-block-id');
        (dupGroups[bid] = dupGroups[bid] || []).push(n);
      });
      Object.keys(dupGroups).forEach(function (bid) {
        var list = dupGroups[bid];
        if (list.length < 2) return;
        var keep = null;
        for (var d = 0; d < list.length; d++) {
          if (list[d].closest('shopify-block, .shopify-block')) { keep = list[d]; break; }
        }
        if (!keep) keep = list[0];
        list.forEach(function (n) { if (n !== keep) n.remove(); });
      });

      var wrappers = Array.prototype.slice.call(document.querySelectorAll('shopify-block, .shopify-block'));
      document.querySelectorAll(TP_SELECTOR).forEach(function (n, i) {
        if (!n.__btOrigWrap || !n.__btOrigWrap.isConnected) {
          var w = n.closest('shopify-block, .shopify-block');
          if (w) n.__btOrigWrap = w;
        }
        var idx = n.__btOrigWrap ? wrappers.indexOf(n.__btOrigWrap) : -1;
        n.setAttribute('data-tp-order', idx >= 0 ? idx : 500 + i);
      });
    }
    stampOrders();

    function insertOrdered(target, el) {
      var mine = parseInt(el.getAttribute('data-tp-order') || '999', 10);
      var before = null;
      for (var i = 0; i < target.children.length; i++) {
        var c = target.children[i];
        if (c === el || !c.getAttribute) continue;
        var o = c.getAttribute('data-tp-order');
        if (o !== null && parseInt(o, 10) > mine) { before = c; break; }
      }
      if (before) target.insertBefore(el, before); else target.appendChild(el);
    }
    function findTarget(pos) {
      if (pos === 'under-summary') {
        return document.querySelector('.cart__summary-container')
            || document.querySelector('[data-cart-summary]')
            || (document.querySelector('.cart__summary-totals') && document.querySelector('.cart__summary-totals').parentElement);
      }
      if (pos === 'under-products') {
        return (document.querySelector('.cart-items__table') && document.querySelector('.cart-items__table').parentElement)
            || document.querySelector('cart-items-component')
            || document.querySelector('.cart-items')
            || document.querySelector('#cart-form');
      }
      return null;
    }
    function moveBlock(el) {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var pos = isMobile ? (el.dataset.posMobile || 'default') : (el.dataset.posDesktop || 'default');
      if (pos === 'default') {
        if (el.__budOrigParent && el.parentElement !== el.__budOrigParent) el.__budOrigParent.appendChild(el);
        return;
      }
      if (!el.__budOrigParent) el.__budOrigParent = el.parentElement;
      var target = findTarget(pos);
      if (target) insertOrdered(target, el);
    }

    function bind(el) {
      if (!el || el.__budReady) return;
      el.__budReady = true;
      moveBlock(el);
    }

    document.querySelectorAll('[data-bt-updivider]').forEach(bind);
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-updivider]').forEach(bind);
    });
    document.addEventListener('shopify:section:load', function () {
      stampOrders();
      document.querySelectorAll('[data-bt-updivider]').forEach(bind);
    });

    /* Кошик morph-иться при видаленні/зміні кількості БЕЗ перезавантаження —
       свіжі елементи блока треба заново привʼязати (телепорт, карусель,
       ціни), інакше апсели вискакують угору «сирими». Детектор у
       MutationObserver дивиться на НЕзаштамповані елементи, тож наші власні
       переміщення (вони вже з data-tp-order) ребайнд не тригерять. */
    var rebindT;
    function scheduleRebind() {
      clearTimeout(rebindT);
      rebindT = setTimeout(function () {
        stampOrders();
        document.querySelectorAll('[data-bt-updivider]').forEach(bind);
      }, 120);
    }
    document.addEventListener('cart:refresh', scheduleRebind);
    document.addEventListener('cart:updated', scheduleRebind);
    document.addEventListener('bricktopia:production-updated', scheduleRebind);
    new MutationObserver(function () {
      if (document.querySelector('[data-bt-updivider]:not([data-tp-order])')) scheduleRebind();
    }).observe(document.body, { childList: true, subtree: true });

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        document.querySelectorAll('[data-bt-updivider]').forEach(moveBlock);
      }, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Position teleport — same pattern as cart-fast-delivery: the merchant
       picks «under products» / «under summary» per breakpoint, we move the
       node there at runtime (the theme editor drops blocks only inside the
       summary column, so mobile placement needs this). */

    /* Порядок телепортнутих блоків = порядок блоків у кастомайзері.
       Перший з апсел-скриптів, що виконався, штампує ВСІ блоки їхнім
       початковим DOM-індексом (серверний рендер Shopify = порядок у
       редакторі), а insertOrdered вставляє за індексом, а не в кінець. */
    var TP_SELECTOR = '[data-cart-fast-delivery],[data-bt-upsell],[data-bt-fupsell],[data-bt-figupsell],[data-bt-updivider]';
    /* Номер порядку беремо з позиції рідної обгортки <shopify-block> серед
       усіх обгорток: вони лишаються на місці після телепорту, тож і після
       ре-рендера секції в редакторі порядок рахується правильно (старий
       one-shot штамп давав новоствореним елементам 999 → блок падав у кінець
       списку, звідси «на ПК порядок не відповідає»). */
    function stampOrders() {
      /* Морф кошика ре-рендерить блок у рідній обгортці, а СТАРА
         телепортнута копія (вона живе вже ПОЗА обгорткою) морфом не
         зноситься → блок дублювався після кожної зміни кошика. Лишаємо
         свіжу копію (ту, що в обгортці), старі прибираємо. */
      var dupGroups = {};
      document.querySelectorAll('[data-bt-block-id]').forEach(function (n) {
        var bid = n.getAttribute('data-bt-block-id');
        (dupGroups[bid] = dupGroups[bid] || []).push(n);
      });
      Object.keys(dupGroups).forEach(function (bid) {
        var list = dupGroups[bid];
        if (list.length < 2) return;
        var keep = null;
        for (var d = 0; d < list.length; d++) {
          if (list[d].closest('shopify-block, .shopify-block')) { keep = list[d]; break; }
        }
        if (!keep) keep = list[0];
        list.forEach(function (n) { if (n !== keep) n.remove(); });
      });

      var wrappers = Array.prototype.slice.call(document.querySelectorAll('shopify-block, .shopify-block'));
      document.querySelectorAll(TP_SELECTOR).forEach(function (n, i) {
        if (!n.__btOrigWrap || !n.__btOrigWrap.isConnected) {
          var w = n.closest('shopify-block, .shopify-block');
          if (w) n.__btOrigWrap = w;
        }
        var idx = n.__btOrigWrap ? wrappers.indexOf(n.__btOrigWrap) : -1;
        n.setAttribute('data-tp-order', idx >= 0 ? idx : 500 + i);
      });
    }
    stampOrders();
    function insertOrdered(target, el) {
      var mine = parseInt(el.getAttribute('data-tp-order') || '999', 10);
      var before = null;
      for (var i = 0; i < target.children.length; i++) {
        var c = target.children[i];
        if (c === el || !c.getAttribute) continue;
        var o = c.getAttribute('data-tp-order');
        if (o !== null && parseInt(o, 10) > mine) { before = c; break; }
      }
      if (before) target.insertBefore(el, before); else target.appendChild(el);
    }

    function findTarget(pos) {
      if (pos === 'under-summary') {
        return document.querySelector('.cart__summary-container')
            || document.querySelector('[data-cart-summary]')
            || (document.querySelector('.cart__summary-totals') && document.querySelector('.cart__summary-totals').parentElement);
      }
      if (pos === 'under-products') {
        return (document.querySelector('.cart-items__table') && document.querySelector('.cart-items__table').parentElement)
            || document.querySelector('cart-items-component')
            || document.querySelector('.cart-items')
            || document.querySelector('#cart-form');
      }
      return null;
    }
    function moveBlock(el) {
      /* Учасників каруселі рухає сам карусельний модуль (обгорткою). */
      if (el.closest('[data-btc-track]')) return;
      var posDesktop = el.dataset.posDesktop || 'default';
      var posMobile = el.dataset.posMobile || 'default';
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var pos = isMobile ? posMobile : posDesktop;
      if (pos === 'default') {
        if (el.__btUpsellOrigParent && el.parentElement !== el.__btUpsellOrigParent) {
          el.__btUpsellOrigParent.appendChild(el);
        }
        return;
      }
      if (!el.__btUpsellOrigParent) el.__btUpsellOrigParent = el.parentElement;
      var target = findTarget(pos);
      if (target) insertOrdered(target, el);
    }

    /* --- Карусель апселів (спільний модуль, визначається ОДИН раз —
       ідентичний код живе і в cart-frame-upsell.liquid під тим самим
       window-guard). Всі блоки з data-bt-carousel="1" збираються в одну
       карусель: свайп на мобілці, стрілки на ПК, крапки-індикатори.
       Позиція та порядок обгортки — від ПЕРШОГО такого блока. --- */
    if (!window.__btUpsellCarousel) {
      window.__btUpsellCarousel = (function () {
        var buildT = null;

        function isMobileMQ() { return window.matchMedia('(max-width: 749px)').matches; }
        function posOf(el) { return isMobileMQ() ? (el.dataset.posMobile || 'default') : (el.dataset.posDesktop || 'default'); }

        function visibleItems() {
          return Array.prototype.slice.call(document.querySelectorAll('[data-bt-carousel="1"]'))
            .filter(function (el) { return el.style.display !== 'none'; })
            .sort(function (a, b) {
              return parseInt(a.getAttribute('data-tp-order') || '999', 10)
                   - parseInt(b.getAttribute('data-tp-order') || '999', 10);
            });
        }

        function slides(wrap) {
          var track = wrap.querySelector('[data-btc-track]');
          return Array.prototype.filter.call(track.children, function (c) {
            return getComputedStyle(c).display !== 'none';
          });
        }

        /* Крок прокрутки = реальна ширина слайда + gap треку. На мобілці
           слайд вужчий за трек (peek наступної картки), тож clientWidth
           треку більше не годиться. */
        function slideStep(wrap) {
          var track = wrap.querySelector('[data-btc-track]');
          var sl = slides(wrap);
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return sl.length ? sl[0].getBoundingClientRect().width + gap : (track.clientWidth || 1);
        }

        function updateNav(wrap) {
          var sl = slides(wrap);
          var track = wrap.querySelector('[data-btc-track]');
          var dots = wrap.querySelector('[data-btc-dots]');
          wrap.classList.toggle('bt-upsell-carousel--single', sl.length < 2);
          var step = slideStep(wrap);
          var idx = step ? Math.round(track.scrollLeft / step) : 0;
          var html = '';
          for (var i = 0; i < sl.length; i++) {
            html += '<button type="button" class="bt-upsell-carousel__dot' + (i === idx ? ' is-active' : '') + '" data-btc-dot="' + i + '" aria-label="' + (i + 1) + '"></button>';
          }
          dots.innerHTML = html;
        }

        /* Власна rAF-анімація скролу: нативний smooth-scrollTo на цьому
           треку глушиться (scroll-snap + тема), пряме присвоєння працює. */
        function animateTo(track, left) {
          var start = track.scrollLeft;
          var delta = left - start;
          if (!delta) return;
          track.__btcAnim = (track.__btcAnim || 0) + 1;
          var myAnim = track.__btcAnim;
          var dur = 320;
          var t0 = null;
          track.style.scrollSnapType = 'none';
          var ticked = false;
          function stepFn(ts) {
            if (track.__btcAnim !== myAnim) return; /* перебито новою анімацією */
            ticked = true;
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / dur);
            var e = 1 - Math.pow(1 - p, 3); /* easeOutCubic */
            track.scrollLeft = start + delta * e;
            if (p < 1) requestAnimationFrame(stepFn);
            else track.style.scrollSnapType = '';
          }
          requestAnimationFrame(stepFn);
          /* rAF не тікає у фонових/прихованих вкладках — тоді стрибаємо
             одразу, щоб клік по стрілці не «з'їдався». */
          setTimeout(function () {
            if (!ticked && track.__btcAnim === myAnim) {
              track.scrollLeft = left;
              track.style.scrollSnapType = '';
            }
          }, 120);
        }
        function goTo(wrap, idx) {
          var track = wrap.querySelector('[data-btc-track]');
          var count = slides(wrap).length;
          if (idx < 0) idx = count - 1;
          if (idx >= count) idx = 0;
          animateTo(track, idx * slideStep(wrap));
        }

        function bindNav(wrap) {
          var track = wrap.querySelector('[data-btc-track]');
          wrap.addEventListener('click', function (e) {
            var t = e.target;
            if (t.hasAttribute('data-btc-prev')) goTo(wrap, Math.round(track.scrollLeft / slideStep(wrap)) - 1);
            else if (t.hasAttribute('data-btc-next')) goTo(wrap, Math.round(track.scrollLeft / slideStep(wrap)) + 1);
            else if (t.hasAttribute('data-btc-dot')) goTo(wrap, parseInt(t.getAttribute('data-btc-dot'), 10));
          });
          var st;
          track.addEventListener('scroll', function () {
            clearTimeout(st);
            st = setTimeout(function () { updateNav(wrap); }, 80);
          });
        }

        function build() {
          var items = visibleItems();
          var wrap = document.querySelector('[data-bt-upsell-carousel]');
          if (items.length < 2) {
            /* 0-1 учасників — карусель не потрібна; розбираємо якщо була */
            if (wrap) {
              var track0 = wrap.querySelector('[data-btc-track]');
              while (track0.firstChild) wrap.parentElement.insertBefore(track0.firstChild, wrap);
              wrap.remove();
            }
            return;
          }
          if (!wrap) {
            wrap = document.createElement('div');
            wrap.className = 'bt-upsell-carousel';
            wrap.setAttribute('data-bt-upsell-carousel', '');
            wrap.innerHTML =
              '<div class="bt-upsell-carousel__track" data-btc-track></div>' +
              '<button type="button" class="bt-upsell-carousel__arrow bt-upsell-carousel__arrow--prev" data-btc-prev aria-label="Prev">&#8249;</button>' +
              '<button type="button" class="bt-upsell-carousel__arrow bt-upsell-carousel__arrow--next" data-btc-next aria-label="Next">&#8250;</button>' +
              '<div class="bt-upsell-carousel__dots" data-btc-dots></div>';
            bindNav(wrap);
          }

          var first = items[0];
          /* Обгортка успадковує позицію/порядок першого учасника і бере
             участь у teleport-логіці нарівні зі звичайними блоками. */
          wrap.dataset.posDesktop = first.dataset.posDesktop || 'default';
          wrap.dataset.posMobile = first.dataset.posMobile || 'default';
          wrap.setAttribute('data-tp-order', first.getAttribute('data-tp-order') || '0');

          var pos = posOf(first);
          if (pos === 'default') {
            /* На місце першого блока (його оригінальний контейнер). */
            var orig = first.__btUpsellOrigParent || first.__bfuOrigParent || first.__bguOrigParent || null;
            var anchor = orig || (!first.closest('[data-btc-track]') ? first.parentElement : null);
            if (anchor && wrap.parentElement !== anchor) anchor.appendChild(wrap);
          } else {
            var target = findTarget(pos);
            if (target) insertOrdered(target, wrap);
          }
          if (!wrap.parentElement && first.parentElement && !first.closest('[data-btc-track]')) {
            first.parentElement.insertBefore(wrap, first);
          }

          var track = wrap.querySelector('[data-btc-track]');
          items.forEach(function (el) { if (el.parentElement !== track) track.appendChild(el); });
          updateNav(wrap);
        }

        function schedule() {
          clearTimeout(buildT);
          buildT = setTimeout(build, 60);
        }

        window.addEventListener('resize', function () {
          clearTimeout(buildT);
          buildT = setTimeout(build, 250);
        });
        window.addEventListener('load', schedule);
        return { schedule: schedule, build: build };
      })();
    }

    /* Auto-size: міряємо РЕАЛЬНУ мініатюру товару в кошику і ставимо такий
       самий розмір + радіус на картинку апселу. Мініатюри рендеряться
       темою по-різному на десктопі/мобілці, тому міряємо DOM, а не
       хардкодимо. Працює коли увімкнено «Розмір як у товарів кошика». */
    function syncMediaSize(el) {
      if (el.dataset.matchCartMedia !== '1') return;
      var ref = document.querySelector('.cart-items__media-container')
             || document.querySelector('.cart-items__media img')
             || document.querySelector('.cart-items__media');
      if (!ref) return;
      var r = ref.getBoundingClientRect();
      if (r.width < 20 || r.height < 20) return; /* ще не завантажилось */
      var size = Math.round(Math.min(r.width, r.height));
      el.style.setProperty('--bt-upsell-media', size + 'px');
      el.style.setProperty('--bt-upsell-media-mobile', size + 'px');
      var br = getComputedStyle(ref).borderRadius;
      if (br && br !== '0px') el.style.setProperty('--bt-upsell-media-radius', br);
    }
    function syncAll() {
      document.querySelectorAll('[data-bt-upsell]').forEach(syncMediaSize);
    }

    function bind(el) {
      if (!el || el.__btUpsellReady) return;
      el.__btUpsellReady = true;
      moveBlock(el);
      syncMediaSize(el);
      /* Ретраї — картинки товарів вантажаться пізніше за DOMContentLoaded,
         і кошик morph-иться після оновлень. */
      setTimeout(function () { syncMediaSize(el); }, 500);
      setTimeout(function () { syncMediaSize(el); }, 1500);

      var btn = el.querySelector('[data-bt-upsell-add]');
      if (!btn) return;
      var variantId = el.getAttribute('data-variant-id');
      if (!variantId) return;
      var addedText = el.getAttribute('data-added-text') || '✓ Added';
      var labelEl = btn.querySelector('.bt-upsell__btn-label');

      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        btn.classList.add('is-loading');

        var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('Cart add failed: ' + r.status);
          return r.json();
        }).then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          if (labelEl) labelEl.textContent = addedText;
          // Notify other cart components to refresh
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'bt-upsell' } }));
          } catch (e) {}
          // Hard reload as the most reliable refresh of the full cart UI
          setTimeout(function () { location.reload(); }, 350);
        }).catch(function (err) {
          console.error('[Cart upsell] Add error:', err);
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
      });
    }

    document.querySelectorAll('[data-bt-upsell]').forEach(bind);
    window.__btUpsellCarousel.schedule();
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-upsell]').forEach(bind);
    });
    /* Редактор тем ре-рендерить секцію на кожну зміну налаштувань — нові
       елементи треба заново заштампувати, привʼязати і рознести по місцях. */
    document.addEventListener('shopify:section:load', function () {
      stampOrders();
      document.querySelectorAll('[data-bt-upsell]').forEach(bind);
      window.__btUpsellCarousel.schedule();
    });

    /* Кошик morph-иться при видаленні/зміні кількості БЕЗ перезавантаження —
       свіжі елементи блока треба заново привʼязати (телепорт, карусель,
       ціни), інакше апсели вискакують угору «сирими». Детектор у
       MutationObserver дивиться на НЕзаштамповані елементи, тож наші власні
       переміщення (вони вже з data-tp-order) ребайнд не тригерять. */
    var rebindT;
    function scheduleRebind() {
      clearTimeout(rebindT);
      rebindT = setTimeout(function () {
        stampOrders();
        document.querySelectorAll('[data-bt-upsell]').forEach(bind);
        window.__btUpsellCarousel.schedule();
      }, 120);
    }
    document.addEventListener('cart:refresh', scheduleRebind);
    document.addEventListener('cart:updated', scheduleRebind);
    document.addEventListener('bricktopia:production-updated', scheduleRebind);
    new MutationObserver(function () {
      if (document.querySelector('[data-bt-upsell]:not([data-tp-order])')) scheduleRebind();
    }).observe(document.body, { childList: true, subtree: true });

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        document.querySelectorAll('[data-bt-upsell]').forEach(moveBlock);
        syncAll();
      }, 200);
    });
    /* Кошик morph-иться після оновлень — переміряти мініатюру. */
    document.addEventListener('cart:refresh', function () { setTimeout(syncAll, 300); });
    document.addEventListener('cart:updated', function () { setTimeout(syncAll, 300); });
    window.addEventListener('load', syncAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quote-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var MAX_PHOTOS = 8;
    var MAX_FILE_MB = 10;

    function init(root) {
      if (!root || root.__btQuoteReady) return;
      root.__btQuoteReady = true;

      var openBtn = root.querySelector('[data-bt-quote-open]');
      var modal = root.querySelector('[data-bt-quote-modal]');
      var form = root.querySelector('[data-bt-quote-form]');
      var fileInput = root.querySelector('[data-bt-quote-files]');
      var uploadLabel = root.querySelector('[data-bt-quote-upload-label]');
      var uploadMeta = root.querySelector('[data-bt-quote-upload-meta]');
      var previews = root.querySelector('[data-bt-quote-previews]');
      var submitBtn = form ? form.querySelector('.bt-quote__submit') : null;
      var successPanel = root.querySelector('[data-bt-quote-success]');
      var errorPanel = root.querySelector('[data-bt-quote-error]');
      var retryBtn = root.querySelector('[data-bt-quote-retry]');
      var NOTIFY_BASE = 'https://web-production-05000.up.railway.app/site/notify';
      var tgSource = root.getAttribute('data-tg-source') || 'Custom quote';
      var productTitle = root.getAttribute('data-product-title') || '';
      var productUrl = root.getAttribute('data-product-url') || '';

      var selectedFiles = []; // array of File objects

      /* Що людина зібрала в калькуляторі. Читаємо в момент відкриття, а не
         при ініціалізації: конфігурацію міняють уже після завантаження. */
      var estBox = root.querySelector('[data-bt-quote-est]');
      var estList = root.querySelector('[data-bt-quote-est-list]');
      function estRows() {
        var e = window.BtEstimate;
        return e && e.rows && e.rows.length ? e.rows : null;
      }
      function estEsc(v) {
        return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
        });
      }
      function renderEstimate() {
        if (!estBox || !estList) return;
        var rows = estRows();
        estBox.hidden = !rows;
        if (!rows) return;
        var html = '';
        rows.forEach(function (r) {
          html += '<dt>' + estEsc(r[0]) + '</dt><dd>' + estEsc(r[1]) + '</dd>';
        });
        estList.innerHTML = html;
      }

      function open() {
        if (!modal) return;
        modal.hidden = false;
        renderEstimate();
        document.body.classList.add('bt-quote-modal-open');
        setTimeout(function () {
          var firstInput = form && form.querySelector('input, textarea');
          if (firstInput) firstInput.focus();
        }, 50);
      }
      function close() {
        if (!modal) return;
        modal.hidden = true;
        document.body.classList.remove('bt-quote-modal-open');
      }

      if (openBtn) openBtn.addEventListener('click', open);
      root.querySelectorAll('[data-bt-quote-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal && !modal.hidden) close();
      });

      // File handling
      function renderPreviews() {
        if (!previews) return;
        previews.innerHTML = '';
        selectedFiles.forEach(function (file, idx) {
          var wrap = document.createElement('div');
          wrap.className = 'bt-quote__preview';
          var img = document.createElement('img');
          img.src = URL.createObjectURL(file);
          img.alt = '';
          img.onload = function () { try { URL.revokeObjectURL(img.src); } catch (e) {} };
          wrap.appendChild(img);
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'bt-quote__preview-remove';
          rm.setAttribute('aria-label', 'Remove');
          rm.textContent = '×';
          rm.addEventListener('click', function () {
            selectedFiles.splice(idx, 1);
            renderPreviews();
            updateMeta();
          });
          wrap.appendChild(rm);
          previews.appendChild(wrap);
        });
      }
      function updateMeta() {
        if (!uploadMeta) return;
        if (!selectedFiles.length) {
          uploadMeta.textContent = 'JPG / PNG / WEBP, do ' + MAX_PHOTOS + ' szt., do ' + MAX_FILE_MB + 'MB';
        } else {
          uploadMeta.textContent = selectedFiles.length + ' z ' + MAX_PHOTOS;
        }
      }
      function addFiles(list) {
        var added = 0, skipped = 0;
        for (var i = 0; i < list.length; i++) {
          var f = list[i];
          if (!f || !f.type || f.type.indexOf('image/') !== 0) { skipped++; continue; }
          if (f.size > MAX_FILE_MB * 1024 * 1024) { skipped++; continue; }
          if (selectedFiles.length >= MAX_PHOTOS) { skipped++; continue; }
          selectedFiles.push(f);
          added++;
        }
        renderPreviews();
        updateMeta();
        if (skipped > 0 && added === 0) {
          alert('Niektóre pliki pominięto: obsługiwane tylko obrazy do ' + MAX_FILE_MB + 'MB.');
        }
      }
      if (fileInput) {
        fileInput.addEventListener('change', function (e) {
          addFiles(e.target.files);
          fileInput.value = ''; // allow re-selecting same file
        });
      }
      if (uploadLabel) {
        ['dragenter', 'dragover'].forEach(function (ev) {
          uploadLabel.addEventListener(ev, function (e) {
            e.preventDefault(); e.stopPropagation();
            uploadLabel.classList.add('is-drop');
          });
        });
        ['dragleave', 'drop'].forEach(function (ev) {
          uploadLabel.addEventListener(ev, function (e) {
            e.preventDefault(); e.stopPropagation();
            uploadLabel.classList.remove('is-drop');
          });
        });
        uploadLabel.addEventListener('drop', function (e) {
          if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
        });
      }
      updateMeta();

      // Contact field adapts to the chosen communication method:
      //   Telegram → text (@tag / link), Email → email, else → phone (country hint)
      var methodRadios = form ? form.querySelectorAll('input[name="messenger"]') : [];
      var contactInput = form ? form.querySelector('[data-bt-quote-contact-input]') : null;
      var contactLabel = form ? form.querySelector('[data-bt-quote-contact-label]') : null;
      function currentMethod() {
        var checked = form ? form.querySelector('input[name="messenger"]:checked') : null;
        return checked ? checked.value : 'Phone';
      }
      function updateContact() {
        if (!contactInput) return;
        var m = currentMethod();
        var kind = 'phone';
        if (m === 'Email') kind = 'email';
        else if (m === 'Telegram') kind = 'telegram';
        if (kind === 'email') {
          contactInput.type = 'email';
          contactInput.inputMode = 'email';
          contactInput.setAttribute('autocomplete', 'email');
        } else if (kind === 'telegram') {
          contactInput.type = 'text';
          contactInput.inputMode = 'text';
          contactInput.setAttribute('autocomplete', 'off');
        } else {
          contactInput.type = 'tel';
          contactInput.inputMode = 'tel';
          contactInput.setAttribute('autocomplete', 'tel');
        }
        var ph = contactInput.getAttribute('data-ph-' + kind);
        if (ph != null) contactInput.placeholder = ph;
        contactInput.setCustomValidity('');
        if (contactLabel) {
          var lb = contactInput.getAttribute('data-label-' + kind);
          if (lb != null) contactLabel.textContent = lb;
        }
      }
      if (methodRadios && methodRadios.length) {
        Array.prototype.forEach.call(methodRadios, function (r) {
          r.addEventListener('change', updateContact);
        });
      }
      // Мінімальна перевірка контакту: телефон має бути схожим на телефон,
      // Telegram — на @нік або t.me/нік. Email валідовує сам браузер (type=email).
      var MSG_PHONE = root.getAttribute('data-msg-phone') || '';
      var MSG_TG = root.getAttribute('data-msg-telegram') || '';
      function validateContact() {
        if (!contactInput) return true;
        var m = currentMethod();
        var v = (contactInput.value || '').trim();
        var msg = '';
        if (v) {
          if (m === 'Telegram') {
            if (!/^(@?[A-Za-z0-9_]{4,32}|(https?:\/\/)?t\.me\/[A-Za-z0-9_]{4,32})$/.test(v)) msg = MSG_TG;
          } else if (m !== 'Email') {
            var digits = v.replace(/[^0-9]/g, '');
            if (digits.length < 9 || digits.length > 15) msg = MSG_PHONE;
          }
        }
        contactInput.setCustomValidity(msg);
        return !msg;
      }
      if (contactInput) {
        contactInput.addEventListener('input', validateContact);
        contactInput.addEventListener('blur', validateContact);
      }

      updateContact();

      /* 24.10.2026: другий обовʼязковий контакт (прапорець two_contacts). */
      function c2Mail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
      function c2Phone(v) { return !/[^\d\s()+\-.]/.test(v) && v.replace(/\D/g, '').length >= 9; }
      function c2Same(a, b) {
        var da = String(a).replace(/\D/g, ''), db = String(b).replace(/\D/g, '');
        if (da.length >= 9 && db.length >= 9 && c2Phone(a) && c2Phone(b)) return da.slice(-9) === db.slice(-9);
        return String(a).trim().toLowerCase().replace(/^@/, '') === String(b).trim().toLowerCase().replace(/^@/, '');
      }
      function c2Fill(lead, list, tgMethod) {
        list.forEach(function (v) {
          v = String(v || '').trim();
          if (!v) return;
          if (c2Mail(v)) { if (!lead.email) lead.email = v; }
          else if (c2Phone(v)) { if (!lead.phone) lead.phone = v; }
          else if (/t\.me\//i.test(v) || (tgMethod && /^@?[A-Za-z][A-Za-z0-9_]{3,31}$/.test(v))) { if (!lead.telegram) lead.telegram = v; }
        });
      }
      var c2Input = form ? form.querySelector('[data-bt-quote-c2-input]') : null;
      var c2Label = form ? form.querySelector('[data-bt-quote-c2-label]') : null;
      var c2Hint = form ? form.querySelector('[data-bt-quote-c2-hint]') : null;
      // Другий контакт: після пошти — телефон; після Telegram — телефон або пошта; інакше — пошта або нік.
      function syncSecond() {
        if (!c2Input) return;
        var m = currentMethod();
        var mail = m === 'Email', tgm = m === 'Telegram';
        if (c2Label) c2Label.textContent = mail ? root.getAttribute('data-c2-phone') : root.getAttribute('data-c2-label');
        if (c2Hint) { c2Hint.textContent = mail ? '' : root.getAttribute(tgm ? 'data-c2-hint-tg' : 'data-c2-hint-any'); c2Hint.hidden = mail; }
        c2Input.type = mail ? 'tel' : 'text';
        c2Input.setAttribute('autocomplete', mail ? 'tel' : 'email');
        c2Input.placeholder = mail ? (contactInput ? contactInput.getAttribute('data-ph-phone') || '' : '') : root.getAttribute(tgm ? 'data-c2-ph-tg' : 'data-c2-ph-any');
      }
      if (methodRadios && methodRadios.length) {
        Array.prototype.forEach.call(methodRadios, function (r) { r.addEventListener('change', syncSecond); });
      }
      syncSecond();

      // Submit handler
      function setLoading(on) {
        if (!submitBtn) return;
        submitBtn.classList.toggle('is-loading', !!on);
        submitBtn.disabled = !!on;
      }
      function showResult(panel) {
        if (form) form.style.display = 'none';
        if (successPanel) successPanel.hidden = panel !== successPanel;
        if (errorPanel) errorPanel.hidden = panel !== errorPanel;
        if (panel) panel.hidden = false;
      }
      function resetView() {
        if (form) form.style.display = '';
        if (successPanel) successPanel.hidden = true;
        if (errorPanel) errorPanel.hidden = true;
      }
      if (retryBtn) retryBtn.addEventListener('click', resetView);

      function buildMessage(data) {
        var lines = ['🎯 *' + tgSource + '*'];
        if (productTitle) lines.push('🛍 Produkt: *' + productTitle + '*');
        lines.push('');
        if (data.name) lines.push('👤 Imię: ' + data.name);
        if (data.messenger) lines.push('💬 Sposób kontaktu: ' + data.messenger);
        if (data.phone) lines.push('📞 Telefon: ' + data.phone);
        if (data.telegram) lines.push('📨 Telegram: ' + data.telegram);
        if (data.email) lines.push('📧 Email: ' + data.email);
        if (data.second) lines.push('📇 ' + (root.getAttribute('data-c2-row') || 'Ще контакт') + ': ' + data.second);
        var est = estRows();
        if (est) {
          lines.push('');
          lines.push('🧮 *Wycena z kalkulatora:*');
          est.forEach(function (r) { lines.push(r[0] + ': ' + r[1]); });
        }
        if (data.idea) {
          lines.push('');
          lines.push('💡 *Pomysł:*');
          lines.push(data.idea);
        }
        if (selectedFiles.length) lines.push('\n📎 Zdjęcia: ' + selectedFiles.length + ' szt. (wysyłane poniżej)');
        if (productUrl) lines.push('\n🌐 ' + productUrl);
        lines.push('⏰ ' + new Date().toLocaleString('pl-PL'));
        return lines.join('\n');
      }

      /* Wysyłka przez backend (kickflip) — token bota żyje tylko na serwerze */
      function fetchTG(path, body, isJson) {
        var url = NOTIFY_BASE + path;
        var opts = { method: 'POST' };
        if (isJson) {
          opts.headers = { 'Content-Type': 'application/json' };
          opts.body = JSON.stringify(body);
        } else {
          opts.body = body; // FormData
        }
        return fetch(url, opts).then(function (r) {
          return r.json().then(function (j) {
            if (!j.ok) throw new Error('Notify' + path + ': ' + (j.error || r.status));
            return j;
          });
        });
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var fd = new FormData(form);
          var method = (fd.get('messenger') || 'Phone').toString().trim();
          var contactVal = (fd.get('contact') || '').toString().trim();
          var data = {
            name: (fd.get('name') || '').toString().trim(),
            messenger: method,
            idea: (fd.get('idea') || '').toString().trim()
          };
          if (method === 'Email') {
            data.email = contactVal;
          } else if (method === 'Telegram') {
            var tg = contactVal;
            if (tg && tg.indexOf('http') !== 0 && tg.charAt(0) !== '@') tg = '@' + tg;
            data.telegram = tg;
          } else {
            data.phone = contactVal;
          }
          if (!data.name || !contactVal || !data.idea) {
            alert('Wypełnij wymagane pola.');
            return;
          }

          if (c2Input) {
            var second = (fd.get('contact2') || '').toString().trim().slice(0, 200);
            var c2msg = '';
            if (second.length < 3) c2msg = root.getAttribute('data-c2-err');
            else if (method === 'Email' && second.replace(/\D/g, '').length < 9) c2msg = root.getAttribute('data-c2-err-phone');
            else if (c2Same(contactVal, second)) c2msg = root.getAttribute('data-c2-same');
            if (c2msg) { alert(c2msg); try { c2Input.focus(); } catch (err) {} return; }
            data.second = second;
            c2Fill(data, [second], method === 'Telegram');
          }

          setLoading(true);

          var files = selectedFiles.slice();
          function photoCaption(i, n) {
            return '📎 Zdjęcie ' + i + '/' + n + (data.name ? ' — ' + data.name : '');
          }
          // Старий шлях для фото: kickflip → Telegram, по одному; збій фото не валить заявку.
          function sendPhotosTG() {
            var queue = Promise.resolve();
            files.forEach(function (file, idx) {
              queue = queue.then(function () {
                var pf = new FormData();
                pf.append('photo', file, file.name || ('photo-' + (idx + 1)));
                pf.append('caption', photoCaption(idx + 1, files.length));
                return fetchTG('/photo', pf, false).catch(function (err) {
                  console.warn('[Bt: Quote] photo ' + (idx + 1) + ' failed:', err);
                });
              });
            });
            return queue;
          }
          function done() {
            setLoading(false);
            showResult(successPanel);
            try { selectedFiles = []; renderPreviews(); updateMeta(); } catch (e) {}
          }
          function fail(err) {
            console.error('[Bt: Quote] submit error:', err);
            setLoading(false);
            showResult(errorPanel);
          }

          /* Заявка йде в склад («Заявки з сайту») через assets/bt-lead.js; склад
             недоступний — bt-lead.js сам шле цей самий Markdown-текст у kickflip.
             btLead перевіряємо тут, у момент надсилання: асет вантажиться defer. */
          var btLead = window.btLead && typeof window.btLead.send === 'function' ? window.btLead : null;
          var sending = null;
          if (btLead) {
            try {
              sending = btLead.send({
                kind: 'custom_quote',
                source: tgSource,
                name: data.name,
                contact_method: method,
                contact: data.second ? (contactVal + ' · ' + data.second).slice(0, 300) : contactVal,
                phone: data.phone || '',
                email: data.email || '',
                telegram: data.telegram || '',
                message: data.idea,
                details: {
                  product: { title: productTitle, url: productUrl },
                  estimate: estRows() || [],
                  photos_planned: files.length
                }
              }, { fallbackText: buildMessage(data), fallbackParseMode: 'Markdown' });
            } catch (err) { sending = null; }
          }
          if (sending && typeof sending.then === 'function') {
            sending.then(function (res) {
              if (!res || !res.ok) throw new Error('lead not delivered' + (res && res.status ? ' (HTTP ' + res.status + ')' : ''));
              if (!files.length) return;
              // Успіх показуємо лише ПІСЛЯ фото, як і раніше. Фото, які склад не прийняв,
              // bt-lead.js досилає в Telegram; via 'telegram' — там і текст, тож підпис старий.
              var uploading;
              try {
                uploading = btLead.uploadPhotos(res, files, {
                  caption: function (i, n, r) { return r && r.via === 'telegram' ? photoCaption(i, n) : ''; }
                });
              } catch (err) { uploading = null; }
              if (!uploading || typeof uploading.then !== 'function') return sendPhotosTG();
              return uploading.then(null, function (err) {
                console.warn('[Bt: Quote] photos failed:', err);
              });
            }).then(done).catch(fail);
            return;
          }

          // Без bt-lead.js — старий шлях: 1) текст, 2) кожне фото
          fetchTG('', {
            text: buildMessage(data),
            parse_mode: 'Markdown'
          }, true).then(sendPhotosTG).then(done).catch(fail);
        });
      }
    }

    document.querySelectorAll('[data-bt-quote]').forEach(init);
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-quote]').forEach(init);
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('[data-bt-quote]').forEach(init);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
